// This client was automatically generated by Segment Typewriter. ** Do Not Edit **
// To update this file, run:
//   npx typewriter

/**
 * Modal with terms and conditions that appears for first time users
 */
export interface AcceptTermsModalViewed {
    referrer?:  string;
    sessionId?: string;
    [property: string]: any;
}

/**
 * User accepts terms and conditions
 */
export interface AcceptTermsTapped {
    referrer?:  string;
    sessionId?: string;
    [property: string]: any;
}

/**
 * User views skill completion message (analog of Skill Completed event which will be fired
 * server-side)
 */
export interface AllSkillStepsCompleted {
    /**
     * number of linkouts in skill
     */
    linkoutCardCount:    number;
    practiceCardCount:   number | null;
    referrer?:           string;
    sessionId?:          string;
    skillId:             string;
    skillPoints:         number;
    skillStepCount:      number;
    understandCardCount: number | null;
    watchCardCount:      number | null;
    [property: string]: any;
}

/**
 * user clicked on app modal
 */
export interface AppModalClicked {
    label: Label;
    [property: string]: any;
}

export enum Label {
    GoToApp = "go to app",
    Stay = "stay",
}

/**
 * User sees app modal
 */
export interface AppModalViewed {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * User selects one of the tabs on the bottom in client app
 */
export interface AppTabSelected {
    referrer?:  string;
    sessionId?: string;
    tab:        AppTabSelectedTab;
    [property: string]: any;
}

export enum AppTabSelectedTab {
    CoachGallery = "coach_gallery",
    CoachedReps = "coached_reps",
    Home = "home",
    Profile = "profile",
    RepGallery = "rep_gallery",
    SocialReps = "social_reps",
}

export interface ButtonClicked {
    label?:     string;
    location?:  string;
    sessionId?: string;
    [property: string]: any;
}

/**
 * Triggered when a user selects a background in the video/photo camera
 */
export interface CameraBackgroundToggled {
    /**
     * The app source where this event was fired
     */
    appSource:      AppSource;
    backgroundType: BackgroundType;
    [property: string]: any;
}

/**
 * The app source where this event was fired
 */
export enum AppSource {
    Admin = "admin",
    Mobile = "mobile",
    Pwa = "pwa",
}

export enum BackgroundType {
    Blur = "blur",
    Image = "image",
    None = "none",
}

/**
 * Fired when we show the list of skill & reps in the new campaign screen
 */
export interface CampaignDetailsToggled {
    /**
     * true if we showing it, false if we are closing the screen by pressing the X button
     */
    showing: boolean;
    /**
     * where do we see this screen from
     */
    source: CampaignDetailsToggledSource;
    [property: string]: any;
}

/**
 * where do we see this screen from
 */
export enum CampaignDetailsToggledSource {
    RepCreator = "rep_creator",
    RepThread = "rep_thread",
    Skill = "skill",
}

export interface CoachFeedViewed {
    referrer?:                 string;
    sessionId?:                string;
    totalRepsAwaitingFeedback: number;
    [property: string]: any;
}

/**
 * Coach views feedback module on rep thread. This module is present for “Pending Reps”.
 */
export interface CoachFeedbackModuleViewed {
    learnerId:   string;
    learnerName: string;
    referrer?:   string;
    repId:       string;
    sessionId?:  string;
    skillId:     string;
    skillName:   string;
    [property: string]: any;
}

export interface CoachRepsHomeModuleViewed {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

export interface CoachRepsSeeAllTapped {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

export interface CommunityTabToggled {
    referrer?:  string;
    sessionId?: string;
    tab:        CommunityTabToggledTab;
    [property: string]: any;
}

export enum CommunityTabToggledTab {
    Everyone = "everyone",
    Me = "me",
}

/**
 * Error after send verification code
 */
export interface FailedSendVerificationCode {
    channel:      Channel;
    errorMessage: string;
    errorName:    null | string;
    referrer?:    string;
    sessionId?:   string;
    /**
     * Possible values are: PWA, CMS
     */
    source: FailedSendVerificationCodeSource;
    to:     string;
    [property: string]: any;
}

export enum Channel {
    Email = "email",
    Phone = "phone",
}

/**
 * Possible values are: PWA, CMS
 */
export enum FailedSendVerificationCodeSource {
    CMS = "cms",
    Pwa = "pwa",
}

/**
 * Error after send verification code
 */
export interface FailedVerifyVerificationCode {
    channel:      Channel;
    errorMessage: string;
    errorName:    null | string;
    referrer?:    string;
    sessionId?:   string;
    source:       FailedSendVerificationCodeSource;
    to:           string;
    [property: string]: any;
}

/**
 * User selects a choice option in forms
 */
export interface FormChoiceSelected {
    /**
     * Choice Id from forms
     */
    choiceId: string;
    /**
     * is this form from a quiz or a survey?
     */
    formDerivedType: FormDerivedType;
    /**
     * id of the form
     */
    formId: string;
    /**
     * minimum correctly answered prompts required to pass
     */
    passingThreshold: number | null;
    /**
     * attempt number at the prompt level, 1 for graded quizzes, 1-n for ungraded quizzes
     */
    promptAttemptNumber: number;
    /**
     * Prompt ID from forms
     */
    promptId: string;
    /**
     * position of Prompt in the form
     */
    promptPosition: number;
    /**
     * Inverse position of the prompt within the form
     */
    promptPositionInverse: number;
    /**
     * The skill ID that the form is associated with
     */
    skillId: string;
    /**
     * The name of the skill the form is associated with
     */
    skillName: string;
    /**
     * total count of prompts in the foorm
     */
    totalPromptCount: number;
    /**
     * attempt number at the form-level
     */
    triesCount: number;
    [property: string]: any;
}

/**
 * is this form from a quiz or a survey?
 *
 *
 *
 * is this form from quiz or survey
 *
 * is this form from a quiz or a survey?
 */
export enum FormDerivedType {
    GradedQuiz = "graded_quiz",
    Survey = "survey",
    UngradedQuiz = "ungraded_quiz",
    Unknown = "unknown",
}

/**
 * Users attempt to submit an answer to a form fails
 */
export interface FormChoiceSubmitFailed {
    choiceIds:       any[];
    errorCode?:      string;
    errorMessage:    string;
    formDerivedType: FormDerivedType;
    formId:          string;
    /**
     * minimum correctly answered prompts required to pass
     */
    passingThreshold:    number | null;
    promptAttemptNumber: number;
    promptId:            string;
    promptPosition:      number;
    skillId:             string;
    skillName:           string;
    totalPromptCount:    number;
    triesCount:          number;
    [property: string]: any;
}

/**
 * Use submits an answer to a form prompt
 */
export interface FormChoiceSubmitted {
    choiceIds:       any[];
    formDerivedType: FormDerivedType;
    formId:          string;
    /**
     * allows null for surveys
     */
    isCorrect: boolean | null;
    /**
     * minimum correctly answered prompts required to pass
     */
    passingThreshold: number | null;
    /**
     * the current attempt number for this prompt
     */
    promptAttemptNumber:   number;
    promptId:              string;
    promptPosition:        number;
    promptPositionInverse: number;
    skillId:               string;
    skillName:             string;
    totalPromptCount:      number;
    /**
     * the current attempt number for this form
     */
    triesCount: number;
    [property: string]: any;
}

/**
 * User views a Intro to form modal
 */
export interface FormIntroViewed {
    /**
     * if current form has failed
     */
    currentFormFailed: boolean;
    /**
     * is this form from quiz or survey
     */
    formDerivedType: FormDerivedType;
    /**
     * Form ID
     */
    formId: string;
    /**
     * maximum number of attempts allowed for this form
     */
    maxTries: number | null;
    /**
     * minimum correctly answered prompts required to pass
     */
    passingThreshold: number | null;
    /**
     * SkillId
     */
    skillId: string;
    /**
     * Name of the skill form is associated with
     */
    skillName: string;
    /**
     * Number of prompts in the form
     */
    totalPromptCount: number;
    /**
     * number of attempt the user has tried this form
     */
    triesCount: number;
    [property: string]: any;
}

/**
 * Firing when user sees a prompt
 */
export interface FormPromptViewed {
    /**
     * is this form from a quiz or a survey?
     */
    formDerivedType: FormDerivedType;
    /**
     * id of the form
     */
    formId: string;
    /**
     * is this prompt completed?
     */
    isCompleted: boolean;
    /**
     * is this prompt failed? can be null if is not completed yet
     */
    isFailed: boolean | null;
    /**
     * true if is fired while user is reviewing his answer
     */
    isReview: boolean;
    /**
     * Maximum number of attempts allowed for the current form
     */
    maxTries: number | null;
    /**
     * minimum correctly answered prompts required to pass
     */
    passingThreshold: number | null;
    /**
     * id of the curent prompt vieed
     */
    promptId: string;
    /**
     * the position of the prompt
     */
    promptPosition: number;
    /**
     * the inverse position of the prompt
     */
    promptPositionInverse: number;
    /**
     * skill id
     */
    skillId: string;
    /**
     * Name of skill associated to form
     */
    skillName: string;
    /**
     * Total number of prompts in the form
     */
    totalPromptCount: number;
    /**
     * number of attempts for the current form
     */
    triesCount: number;
    [property: string]: any;
}

/**
 * user views a retry modal due to failing a form
 */
export interface FormRetryModalViewed {
    /**
     * boolean of if user can retry current form
     */
    canBeRetried: boolean;
    /**
     * is this form from a quiz or a survey?
     */
    formDerivedType: FormDerivedType;
    formId:          string;
    /**
     * Maximum number of attempts a user can retry form
     */
    maxTries: number | null;
    /**
     * minimum correctly answered prompts required to pass
     */
    passingThreshold: number | null;
    /**
     * Skill ID
     */
    skillId:          string;
    skillName:        string;
    totalPromptCount: number;
    /**
     * number of attempts user tried current form
     */
    triesCount: number;
    [property: string]: any;
}

/**
 * User has clicked to retry a failed form
 */
export interface FormRetrySelected {
    /**
     * is this form from a quiz or a survey?
     */
    formDerivedType: FormDerivedType;
    /**
     * ID of the form
     */
    formId: string;
    /**
     * Maximum number of attempts allowed for the current form
     */
    maxTries: number | null;
    /**
     * minimum correctly answered prompts required to pass
     */
    passingThreshold: number | null;
    /**
     * skill ID
     */
    skillId: string;
    /**
     * Name of skill associated to form
     */
    skillName: string;
    /**
     * where did the user click the retry button? retryModal or intro Modal
     */
    source: FormRetrySelectedSource;
    /**
     * Total number of prompts in the form
     */
    totalPromptCount: number;
    /**
     * number of attempts for the current form
     */
    triesCount: number;
    [property: string]: any;
}

/**
 * where did the user click the retry button? retryModal or intro Modal
 */
export enum FormRetrySelectedSource {
    Card = "card",
    IntroModal = "intro_modal",
    RetryModal = "retry_modal",
}

/**
 * User has clicked to review a failed form
 */
export interface FormReviewSelected {
    /**
     * is this form from a quiz or a survey?
     */
    formDerivedType: FormDerivedType;
    /**
     * current form id
     */
    formId: string;
    /**
     * max tries for the form
     */
    maxTries: number | null;
    /**
     * minimum correctly answered prompts required to pass
     */
    passingThreshold: number | null;
    /**
     * Skill Id
     */
    skillId: string;
    /**
     * Name of skill associated to form
     */
    skillName: string;
    /**
     * did the user select to review the form from the modal or dismiss the modal
     */
    source?: FormReviewSelectedSource;
    /**
     * total prompts in the form
     */
    totalPromptCount: number;
    /**
     * the current attempt number for the form
     */
    triesCount: number;
    [property: string]: any;
}

/**
 * did the user select to review the form from the modal or dismiss the modal
 */
export enum FormReviewSelectedSource {
    DismissFormIntroModal = "dismissFormIntroModal",
    FormIntroModal = "formIntroModal",
}

export interface GalleryFilterApplied {
    filtersApplied: GalleryFilterAppliedFiltersApplied;
    galleryType:    GalleryFilterAppliedGalleryType;
    tab:            GalleryFilterAppliedTab;
    [property: string]: any;
}

export interface GalleryFilterAppliedFiltersApplied {
    learnerCompanyProfileId?: string;
    promptId?:                string;
    /**
     * always sent when applying a filter in coach gallery
     */
    status?: Status;
    [property: string]: any;
}

/**
 * always sent when applying a filter in coach gallery
 */
export enum Status {
    All = "all",
    Approved = "approved",
    New = "new",
    Reviewed = "reviewed",
    Submitted = "submitted",
}

export enum GalleryFilterAppliedGalleryType {
    Coach = "coach",
    Reps = "reps",
}

export enum GalleryFilterAppliedTab {
    Approved = "approved",
    Coach = "coach",
    Peers = "peers",
    Review = "review",
}

/**
 * When you land on the gallery (either learner or coach) via deeplink or from tab menu.
 * Only fire when first clicking into gallery. If filters are applied after viewing gallery
 * fire the gallery filter applied event instead.
 */
export interface GalleryViewed {
    filtersApplied: GalleryViewedFiltersApplied;
    galleryType:    GalleryViewedGalleryType;
    [property: string]: any;
}

export interface GalleryViewedFiltersApplied {
    learnerCompanyProfileId?: string;
    promptId?:                string;
    /**
     * always sent when applying a filter in coach gallery
     */
    status?: Status;
    [property: string]: any;
}

export enum GalleryViewedGalleryType {
    Coach = "coach",
    CoachedReps = "coached_reps",
    Reps = "reps",
    SocialReps = "social_reps",
}

/**
 * while on the screen when we’re waiting to generate the AI, and user taps a button
 */
export interface GeneratingAIAnalysisButtonTapped {
    buttonTapped: ButtonTapped;
    repId:        string;
    [property: string]: any;
}

export enum ButtonTapped {
    Home = "home",
    StartPractice = "startPractice",
    SubmitReps = "submitReps",
}

export interface GoogleSigninAuthVerifyFailure {
    cause?:    string;
    email?:    string;
    referrer?: string;
    source?:   string;
    [property: string]: any;
}

/**
 * Failed to Signin with Google
 */
export interface GoogleSigninFailure {
    cause?:    string;
    email?:    string;
    referrer?: string;
    source?:   string;
    [property: string]: any;
}

/**
 * Successful Signin with Google
 */
export interface GoogleSigninSuccess {
    email?:     string;
    referrer?:  string;
    sessionId?: string;
    source?:    string;
    [property: string]: any;
}

/**
 * URL login; used when Uber users click on link
 */
export interface InboundURLAuthorized {
    companyExternalId:      null | string;
    competencyExternalId:   null | string;
    instanceId:             null | string;
    isSuccess:              boolean;
    learningPlanExternalId: null | string;
    profileExternalId:      null | string;
    sessionId?:             string;
    skillExternalId:        null | string;
    url:                    string;
    [property: string]: any;
}

/**
 * Information viewed when tapping info/question icon
 */
export interface InfoViewed {
    referrer?:  string;
    sessionId?: string;
    source:     string;
    [property: string]: any;
}

/**
 * User clicked a link in the left hand navigation panel
 */
export interface LHSNavigationClicked {
    learningPlanId?: string;
    lpFolderId?:     string;
    referrer?:       string;
    sectionName?:    string;
    sessionId?:      string;
    [property: string]: any;
}

/**
 * Fired when picking a sort type
 */
export interface LHSNavigationPickedSort {
    sortType: SortType;
    [property: string]: any;
}

export enum SortType {
    Alphabetically = "alphabetically",
    Latest = "latest",
}

/**
 * Language modal that appears for first time users when they login
 */
export interface LanguageModalViewed {
    defaultLanguage:   string;
    listOfLanguages:   string[];
    numberOfLanguages: number;
    referrer?:         string;
    sessionId?:        string;
    [property: string]: any;
}

/**
 * When user updates their language
 */
export interface LanguageUpdated {
    previousLanguage: null | string;
    referrer?:        string;
    selectedLanguage: string;
    sessionId?:       string;
    [property: string]: any;
}

/**
 * Fires when user lands on their dashboard page.
 */
export interface LearnerDashboardViewed {
    completedSkillCount: number;
    isCoach:             boolean;
    proScore?:           number;
    referrer?:           string;
    sessionId?:          string;
    startedSkillCount:   number;
    totalRepCount?:      number;
    totalSkillCount:     number;
    totalToDoRepCount?:  number;
    [property: string]: any;
}

export interface LearningPlanDetailsClosed {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * Fired when tapping a learning plan
 */
export interface LearningPlanSelected {
    externalId:  null | string;
    id:          null | string;
    isCompleted: boolean | null;
    isLocked:    boolean | null;
    name:        null | string;
    /**
     * position in list (index)
     */
    position:   number;
    progress:   number | null;
    repCount:   number | null;
    skillCount: number | null;
    source:     LearningPlanSelectedSource | null;
    [property: string]: any;
}

export enum LearningPlanSelectedSource {
    LearningPlanScreen = "learning_plan_screen",
    LearningPlansHomeModule = "learning_plans_home_module",
}

/**
 * Fired when we get the LP details on the LP screen.
 */
export interface LearningPlanViewed {
    /**
     * reps where status = approved
     */
    approvedRepCount: number;
    /**
     * skills with progress = 1.0
     */
    completedSkillCount: number;
    externalId:          null | string;
    id:                  null | string;
    /**
     * progress = 1.0
     */
    isCompleted: boolean;
    isLocked:    boolean;
    /**
     * reps where status = locked
     */
    lockedRepCount: number;
    name:           null | string;
    /**
     * reps where status = new
     */
    newRepCount: number;
    progress:    number;
    repCount:    number;
    /**
     * reps where status = reviewed
     */
    reviewedRepCount: number;
    skillCount:       number;
    /**
     * skills with progress > 0.0
     */
    startedSkillCount: number;
    /**
     * reps where status = submitted
     */
    submittedRepCount: number;
    [property: string]: any;
}

/**
 * Fired when learning plans screen is closed
 */
export interface LearningPlansClosed {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

export interface LearningPlansHomeModuleViewed {
    count: number | null;
    [property: string]: any;
}

export interface LearningPlansSeeAllTapped {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * Fired when we get a page of learning plans from the backend
 */
export interface LearningPlansViewed {
    /**
     * how many LPs we can currently show to the user
     */
    currentCount: number;
    /**
     * how many LPs were returned in this response
     */
    responseCount: number;
    /**
     * how many LPs are assigned to the current user
     */
    totalCount: number;
    [property: string]: any;
}

export interface LinkClicked {
    label?:     string;
    linkName?:  string;
    sessionId?: string;
    to:         string;
    [property: string]: any;
}

export interface LinkoutOpened {
    isSkillComplete:  boolean;
    learningCardId:   string;
    referrer?:        string;
    sessionId?:       string;
    skillDescription: string;
    skillId:          string;
    url:              string;
    [property: string]: any;
}

/**
 * Triggered when a user selects a person from the suggestions popup
 */
export interface MentionSelected {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * Triggered when a user writes @ + a letter
 */
export interface MentionStarted {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * Triggered when a user submits a comment with mention(s)
 */
export interface MentionSubmitted {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * User requests a new code
 */
export interface NewCodeRequested {
    channel?:   Channel;
    referrer?:  string;
    sessionId?: string;
    source:     FailedSendVerificationCodeSource;
    to:         string;
    [property: string]: any;
}

/**
 * Fired when UI is at least partially visible
 */
export interface NextSkillHomeModuleViewed {
    repAssignmentId:                 null | string;
    repAssignmentStatus:             RepStatus | null;
    repSubmissionCount:              number | null;
    skillCompleted:                  boolean | null;
    skillExternalId:                 null | string;
    skillLocked:                     boolean | null;
    skillLpCompanySectionExternalId: null | string;
    type:                            Type;
    [property: string]: any;
}

export enum RepStatus {
    Approved = "approved",
    New = "new",
    Practiced = "practiced",
    Reviewed = "reviewed",
    Submitted = "submitted",
    Unknown = "unknown",
}

export enum Type {
    Rep = "rep",
    Skill = "skill",
    Unknown = "unknown",
}

/**
 * Learner views next skill module if the rep is approved and there is an incomplete skill.
 * This module is present for “Approved Reps”
 */
export interface NextSkillModuleViewed {
    nextSkillId?:   string;
    nextSkillName?: string;
    referrer?:      string;
    repId:          string;
    sessionId?:     string;
    skillId:        string;
    skillName:      string;
    [property: string]: any;
}

/**
 * When selected a country
 */
export interface PhoneCountryChanged {
    previousCountry: string;
    referrer?:       string;
    selectedCountry: string;
    sessionId?:      string;
    [property: string]: any;
}

export interface PhotoSourceSelected {
    captureMode: CaptureMode;
    referrer?:   string;
    sessionId?:  string;
    source:      PhotoSourceSelectedSource;
    [property: string]: any;
}

export enum CaptureMode {
    Photo = "photo",
    Unknown = "unknown",
    Video = "video",
}

export enum PhotoSourceSelectedSource {
    Camera = "camera",
    Library = "library",
    Unknown = "unknown",
}

/**
 * Learner views ProScore module which displays ProScore information as a part of a larger
 * screen
 */
export interface ProScoreModuleViewed {
    points:          number;
    proScore:        number;
    proScoreRounded: number;
    referrer?:       string;
    repsApproved:    number;
    sessionId?:      string;
    skillsAssigned:  number;
    skillsCompleted: number;
    source:          string;
    [property: string]: any;
}

/**
 * Learner opens up the ProScore modal
 */
export interface ProScoreViewed {
    points:          number;
    proScore:        number;
    proScoreRounded: number;
    referrer?:       string;
    repsApproved:    number;
    sessionId?:      string;
    skillsAssigned:  number;
    skillsCompleted: number;
    source:          ProScoreViewedSource;
    [property: string]: any;
}

export enum ProScoreViewedSource {
    Dashboard = "dashboard",
    Modal = "modal",
}

/**
 * A button from the profile item was clicked
 */
export interface ProfileButtonItemTapped {
    /**
     * the text of the button
     */
    buttonText: string;
    [property: string]: any;
}

/**
 * Fired when we click the profile icon from home
 */
export interface ProfileButtonTapped {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * User taps on delete option to remove the profile photo
 */
export interface ProfilePhotoDelete {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * User picks the option to take a photo from the camera
 */
export interface ProfilePhotoEditFromCamera {
    /**
     * true if the user previously had a uploaded profile photo
     */
    hasExistingPhoto: boolean;
    [property: string]: any;
}

/**
 * User picks the option to pick a photo from the library
 */
export interface ProfilePhotoEditFromLibrary {
    /**
     * true if the user previously had a uploaded profile photo
     */
    hasExistingPhoto: boolean;
    [property: string]: any;
}

/**
 * Fired when the user tapped the avatar
 */
export interface ProfilePhotoEditTapped {
    /**
     * true if the user previously had a uploaded profile photo
     */
    hasExistingPhoto: boolean;
    [property: string]: any;
}

/**
 * Fires when there is an error to delete the photo, or update it, or upload it to cloudinary
 */
export interface ProfilePhotoUpdateFailed {
    /**
     * the reason for the error, or any relevant info to debug the cause
     */
    error?: string;
    [property: string]: any;
}

/**
 * Fired when we successfully edit the profile image (changed or deleted)
 */
export interface ProfilePhotoUpdateSuccess {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * Fire if the profile image upload is cancelled
 */
export interface ProfilePhotoUploadCancelled {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * Fired when the image upload failed
 */
export interface ProfilePhotoUploadFailed {
    error: null | string;
    [property: string]: any;
}

/**
 * Fired when the image upload was successful
 */
export interface ProfilePhotoUploadSuccess {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * User selects a learning card (e.g. video) rating
 */
export interface RatedLearningCard {
    learningCardId:     string;
    learningCardType:   RatedLearningCardLearningCardType;
    linkoutProgress:    number | null;
    practiceProgress:   number | null;
    rating:             number | null;
    ratingType:         RatingType;
    referrer?:          string;
    sessionId?:         string;
    skillId:            string;
    skillName:          string;
    skillProgress:      number | null;
    understandProgress: number | null;
    watchProgress:      number | null;
    [property: string]: any;
}

export enum RatedLearningCardLearningCardType {
    File = "file",
    FlashCard = "flash_card",
    Linkout = "linkout",
    Quiz = "quiz",
    Unknown = "unknown",
    Video = "video",
}

export enum RatingType {
    Thumbs = "thumbs",
}

/**
 * User selects a skill rating
 */
export interface RatedSkill {
    linkoutProgress:    number | null;
    practiceProgress:   number | null;
    rating:             number | null;
    ratingType:         RatingType;
    referrer?:          string;
    sessionId?:         string;
    skillId:            string;
    skillName:          string;
    skillProgress:      number | null;
    understandProgress: number | null;
    watchProgress:      number | null;
    [property: string]: any;
}

/**
 * A rating modal from a learning card is dismissed automatically or by the user
 */
export interface RatingModalDismissed {
    action:           RatingModalDismissedAction;
    learningCardId:   string;
    learningCardType: RatedLearningCardLearningCardType;
    rating?:          number;
    ratingType?:      RatingType;
    referrer?:        string;
    sessionId?:       string;
    skillId:          string;
    [property: string]: any;
}

export enum RatingModalDismissedAction {
    Closed = "closed",
    SelectedRating = "selected_rating",
    Timeout = "timeout",
}

/**
 * A rating modal is displayed to the user
 */
export interface RatingModalViewed {
    learningCardId:     string;
    learningCardType:   RatingModalViewedLearningCardType;
    linkoutProgress:    number | null;
    practiceProgress:   number | null;
    rating:             number | null;
    ratingType:         RatingType;
    referrer?:          string;
    sessionId?:         string;
    skillId:            string;
    skillProgress:      number;
    understandProgress: number | null;
    watchProgress:      number | null;
    [property: string]: any;
}

export enum RatingModalViewedLearningCardType {
    File = "file",
    FlashCard = "flash_card",
    Form = "form",
    Linkout = "linkout",
    Quiz = "quiz",
    Unknown = "unknown",
    Video = "video",
}

/**
 * Triggered when a user clicks on any available option of the camera or audio recorder
 */
export interface RecorderOptionClicked {
    /**
     * The app source where this event was fired
     */
    appSource:    AppSource;
    buttonType:   ButtonType;
    responseType: RecorderOptionClickedResponseType;
    [property: string]: any;
}

export enum ButtonType {
    Backgrounds = "backgrounds",
    CameraOff = "cameraOff",
    CameraOn = "cameraOn",
    MicOff = "micOff",
    MicOn = "micOn",
    RecordScreenStarted = "recordScreenStarted",
    RecordScreenStopped = "recordScreenStopped",
    Settings = "settings",
    TeleprompterOff = "teleprompterOff",
    TeleprompterOn = "teleprompterOn",
    Upload = "upload",
}

export enum RecorderOptionClickedResponseType {
    Audio = "audio",
    Image = "image",
    Video = "video",
}

/**
 * Fired when tapping one of the buttons in the rep thread
 */
export interface RepAISectionOpened {
    repId:             string;
    repSubmissionId:   string;
    repSubmissionType: RepAISectionOpenedRepSubmissionType;
    sectionType:       SectionType;
    [property: string]: any;
}

export enum RepAISectionOpenedRepSubmissionType {
    Conversation = "conversation",
    Video = "video",
}

export enum SectionType {
    Articulation = "articulation",
    Conversation = "conversation",
    Keywords = "keywords",
}

/**
 * Fired when tapped a rep thread tab from the AI section
 */
export interface RepAITabTapped {
    repAssignmentId: string;
    repSubmissionId: string;
    tab:             RepAITabTappedTab;
    [property: string]: any;
}

export enum RepAITabTappedTab {
    AIAnalysis = "aiAnalysis",
    Transcript = "transcript",
}

/**
 * fired when tapped the articulation to expand to show more AI data
 */
export interface RepArticulationToggled {
    repAssignmentId: string;
    repSubmissionId: string;
    /**
     * true if the tap was made to expand the articulation, false otherwise
     */
    showArticulation: boolean;
    [property: string]: any;
}

/**
 * Learner views rep creator module on rep thread. This module is present for “New Reps” and
 * “Feedback Reps”
 */
export interface RepCreatorModuleViewed {
    allowedResponseTypes: ResponseTypeElement[];
    /**
     * Coach ID If it's a coached Rep, null otherwise
     */
    coachId: null | string;
    /**
     * Coach Name If it's a coached Rep, null otherwise
     */
    coachName: null | string;
    referrer?: string;
    /**
     * Rep assignment ID
     */
    repId:      string;
    repType:    RepType;
    sessionId?: string;
    skillId:    string;
    skillName:  string;
    [property: string]: any;
}

export enum ResponseTypeElement {
    Audio = "audio",
    Conversation = "conversation",
    Image = "image",
    PDF = "pdf",
    Text = "text",
    Unknown = "unknown",
    Video = "video",
}

export enum RepType {
    Coached = "coached",
    Social = "social",
    Unknown = "unknown",
}

/**
 * User opens rep creator using the rep creator icon (+)
 */
export interface RepCreatorViewed {
    assignedRepsCount: number;
    referrer?:         string;
    sessionId?:        string;
    [property: string]: any;
}

/**
 * Views modal accompanying rep card that surfaces rep prompt
 */
export interface RepDetailsSelected {
    isCoach:    boolean;
    referrer?:  string;
    repId:      string;
    repStatus?: RepDetailsSelectedRepStatus;
    repType?:   RepType;
    sessionId?: string;
    skillId?:   string;
    skillName:  string;
    userRole:   RepDetailsSelectedUserRole;
    [property: string]: any;
}

export enum RepDetailsSelectedRepStatus {
    Approved = "approved",
    Done = "done",
    New = "new",
    Practiced = "practiced",
    Reviewed = "reviewed",
    Submitted = "submitted",
    Unknown = "unknown",
}

export enum RepDetailsSelectedUserRole {
    Coach = "coach",
    Learner = "learner",
}

/**
 * Views modal accompanying rep card that surfaces rep prompt
 */
export interface RepDetailsViewed {
    isCoach:    boolean;
    referrer?:  string;
    repId:      string;
    repStatus?: RepDetailsSelectedRepStatus;
    repType?:   RepType;
    sessionId?: string;
    skillId?:   string;
    skillName:  string;
    userRole:   RepDetailsSelectedUserRole;
    [property: string]: any;
}

export interface RepFeedbackSubmissionFailed {
    errorCode?: string;
    /**
     * error from response OR hint/error message we are showing to the user
     */
    errorMessage: null | string;
    feedbackType: FeedbackType;
    referrer?:    string;
    /**
     * rep assignment id
     */
    repId:      string;
    repType?:   RepType;
    sessionId?: string;
    [property: string]: any;
}

export enum FeedbackType {
    Approval = "approval",
    Comment = "comment",
    Feedback = "feedback",
    Unknown = "unknown",
}

/**
 * Feedback is submitted successfully for a rep
 */
export interface RepFeedbackSubmissionSuccess {
    feedbackType: FeedbackType;
    referrer?:    string;
    repId:        string;
    repType?:     RepType;
    sessionId?:   string;
    [property: string]: any;
}

export interface RepFeedbackTypeSelected {
    feedbackType: string;
    referrer?:    string;
    repId:        string;
    repType?:     RepType;
    sessionId?:   string;
    skillId:      string;
    source:       RepFeedbackTypeSelectedSource;
    [property: string]: any;
}

export enum RepFeedbackTypeSelectedSource {
    CoachPortfolio = "coach portfolio",
    RepThread = "rep thread",
}

/**
 * fired when tapped Next skill while on the rep thread
 */
export interface RepNextSkillTapped {
    nextRepAssignmentId: null | string;
    nextSkillId:         null | string;
    nextSkillType:       NextSkillType;
    /**
     * the rep assignment id of the rep we currently show
     */
    repAssignmentId: string;
    [property: string]: any;
}

export enum NextSkillType {
    Rep = "rep",
    Skill = "skill",
}

/**
 * User selects one of the reps from their portfolio
 */
export interface RepOpened {
    /**
     * rep assignment id
     */
    repId: string;
    /**
     * id of the rep prompt
     */
    repPromptId: string;
    repStatus:   RepOpenedRepStatus;
    /**
     * title of the rep
     */
    repTitle:   string;
    repType:    RepType;
    sessionId?: string;
    source:     RepOpenedSource;
    /**
     * Company Profile ID of the Submitter
     */
    submitterId: null | string;
    userRole:    RepOpenedUserRole;
    [property: string]: any;
}

export enum RepOpenedRepStatus {
    Approved = "approved",
    Done = "done",
    New = "new",
    Practiced = "practiced",
    Reviewed = "reviewed",
    Submitted = "submitted",
}

export enum RepOpenedSource {
    Campaign = "campaign",
    CoachGallery = "coach_gallery",
    CoachRepsHomeModule = "coach_reps_home_module",
    Home = "home",
    NextSkillHomeModule = "next_skill_home_module",
    RepsGallery = "reps_gallery",
    SkillCompletionModal = "skill_completion_modal",
    SocialRepsHomeModule = "social_reps_home_module",
}

export enum RepOpenedUserRole {
    Coach = "coach",
    Learner = "learner",
    Peer = "peer",
}

export interface RepPromptToggled {
    action: RepPromptToggledAction;
    /**
     * rep assignment id
     */
    repId:             string;
    repSubmissionType: SubmissionType;
    source:            RepPromptToggledSource;
    [property: string]: any;
}

export enum RepPromptToggledAction {
    Close = "close",
    Open = "open",
}

export enum SubmissionType {
    Audio = "audio",
    Conversation = "conversation",
    Image = "image",
    PDF = "pdf",
    Text = "text",
    Video = "video",
}

export enum RepPromptToggledSource {
    RepCreator = "rep_creator",
    RepView = "rep_view",
}

export interface RepResponseAudioTapped {
    action:     RepResponseAudioTappedAction;
    referrer?:  string;
    repId:      string;
    repType?:   RepType;
    sessionId?: string;
    skillId:    string;
    /**
     * Used for scrubbed
     */
    toSeconds?: number;
    url:        string;
    userRole:   RepDetailsSelectedUserRole;
    [property: string]: any;
}

export enum RepResponseAudioTappedAction {
    Paused = "paused",
    Played = "played",
    Scrubbed = "scrubbed",
}

export interface RepResponseCancel {
    /**
     * type of action. enum says its name
     */
    actionType: ActionType | null;
    [property: string]: any;
}

export enum ActionType {
    Canceled = "canceled",
    Confirmed = "confirmed",
    Viewed = "viewed",
}

/**
 * Rep ready for preview
 */
export interface RepResponseCaptured {
    /**
     * duration of the video / audio in seconds
     */
    duration?: number;
    /**
     * rep assignment id
     */
    repId:        string;
    responseType: RepResponseCapturedResponseType;
    source:       RepResponseCapturedSource;
    [property: string]: any;
}

export enum RepResponseCapturedResponseType {
    Audio = "audio",
    Image = "image",
    Text = "text",
    Video = "video",
}

export enum RepResponseCapturedSource {
    FrontCamera = "frontCamera",
    Microphone = "microphone",
    RearCamera = "rearCamera",
    TextInput = "textInput",
    Upload = "upload",
}

/**
 * Triggered when a user clicks on the X icon of the Rep creator
 */
export interface RepResponseExit {
    /**
     * Type of action is a confirmation message is shown, null otherwise
     */
    actionType: ActionType | null;
    [property: string]: any;
}

export interface RepResponseImageTapped {
    repId:    string;
    skillId:  string;
    url:      string;
    userRole: RepDetailsSelectedUserRole;
    [property: string]: any;
}

/**
 * The rep response preview is shown. This is prior to the user submitting the response
 */
export interface RepResponsePreviewed {
    referrer?:    string;
    repType?:     RepType;
    responseType: ResponseTypeElement;
    sessionId?:   string;
    skillId:      string;
    [property: string]: any;
}

/**
 * Start recording (video/audio)
 */
export interface RepResponseRecordingStarted {
    /**
     * rep assignment id
     */
    repId:        string;
    responseType: RepResponseRecordingStartedResponseType;
    [property: string]: any;
}

export enum RepResponseRecordingStartedResponseType {
    Audio = "audio",
    Video = "video",
}

/**
 * When tapping redo after previewing a rep
 */
export interface RepResponseRedoTapped {
    /**
     * rep assignment id
     */
    repId:             string;
    repSubmissionType: RepResponseRedoTappedRepSubmissionType;
    [property: string]: any;
}

export enum RepResponseRedoTappedRepSubmissionType {
    Audio = "audio",
    Conversation = "conversation",
    Image = "image",
    Text = "text",
    Video = "video",
}

export interface RepResponseSubmissionCanceled {
    repId:        string;
    repType?:     RepType;
    responseType: ResponseTypeElement;
    sessionId?:   string;
    [property: string]: any;
}

/**
 * The attempt to submit rep response failed
 */
export interface RepResponseSubmissionFailed {
    errorCode?:   string;
    errorMessage: null | string;
    referrer?:    string;
    repId:        string;
    repType?:     RepType;
    responseType: RepResponseSubmissionFailedResponseType;
    sessionId?:   string;
    skillId:      string;
    skillName:    string;
    userRole:     RepDetailsSelectedUserRole;
    [property: string]: any;
}

export enum RepResponseSubmissionFailedResponseType {
    Audio = "audio",
    Image = "image",
    PDF = "pdf",
    Text = "text",
    Unknown = "unknown",
    Video = "video",
}

/**
 * The rep response was submitted successfully.
 */
export interface RepResponseSubmissionSuccess {
    referrer?:    string;
    repId:        string;
    repType?:     RepType;
    responseType: ResponseTypeElement;
    sessionId?:   string;
    skillId:      string;
    skillName:    string;
    userRole:     RepDetailsSelectedUserRole;
    [property: string]: any;
}

/**
 * User submits a response on rep thread
 */
export interface RepResponseSubmitted {
    referrer?:    string;
    repId:        string;
    repStatus:    RepStatus;
    repType?:     RepType;
    responseType: ResponseTypeElement;
    sessionId?:   string;
    skillId:      string;
    skillName:    string;
    userRole:     RepDetailsSelectedUserRole;
    [property: string]: any;
}

/**
 * User selects a response type in Rep Creator and starts the rep creation process.
 */
export interface RepResponseTypeSelected {
    referrer?:    string;
    repId:        string;
    repType?:     RepType;
    responseType: ResponseTypeElement;
    sessionId?:   string;
    skillId:      string;
    [property: string]: any;
}

export interface RepResponseUploadCancelled {
    /**
     * File size of uploaded content in kb
     */
    fileSizeKb: number;
    /**
     * Network Type
     */
    networkType:  NetworkType;
    referrer?:    string;
    repId:        string;
    repStatus:    RepResponseUploadCancelledRepStatus;
    repType?:     RepType;
    responseType: ResponseTypeElement;
    sessionId?:   string;
    skillId:      string;
    skillName:    string;
    /**
     * Time taken to upload content before cancelling (seconds)
     */
    uploadTimeSeconds: number;
    [property: string]: any;
}

/**
 * Network Type
 *
 * Network type
 */
export enum NetworkType {
    Cellular = "cellular",
    Unavailable = "unavailable",
    Unknown = "unknown",
    Wifi = "wifi",
}

export enum RepResponseUploadCancelledRepStatus {
    Approved = "approved",
    Locked = "locked",
    New = "new",
    Reviewed = "reviewed",
    Submitted = "submitted",
    Unknown = "unknown",
}

export interface RepResponseUploadFailed {
    errorCode?:   string;
    errorMessage: string;
    /**
     * File size of uploaded content in kb
     */
    fileSizeKb: number;
    /**
     * Error returned by the request
     */
    networkError?: { [key: string]: any };
    /**
     * Network type
     */
    networkType:  NetworkType;
    referrer?:    string;
    repId:        string;
    repStatus:    RepResponseUploadFailedRepStatus;
    repType?:     RepType;
    responseType: ResponseTypeElement;
    sessionId?:   string;
    skillId:      string;
    skillName:    string;
    /**
     * Time taken to upload content before error (seconds)
     */
    uploadTimeSeconds: number;
    [property: string]: any;
}

export enum RepResponseUploadFailedRepStatus {
    Approved = "approved",
    New = "new",
    Reviewed = "reviewed",
    Submitted = "submitted",
    Unknown = "unknown",
}

export interface RepResponseUploadSuccess {
    /**
     * File size of uploaded content in kb
     */
    fileSizeKb: number;
    /**
     * Network type
     */
    networkType:  NetworkType;
    referrer?:    string;
    repId:        string;
    repStatus:    RepResponseUploadFailedRepStatus;
    repType?:     RepType;
    responseType: ResponseTypeElement;
    sessionId?:   string;
    skillId:      string;
    skillName:    string;
    /**
     * Time taken to upload content (seconds)
     */
    uploadTimeSeconds: number;
    [property: string]: any;
}

export interface RepResponseVideoTapped {
    action?:    RepResponseVideoTappedAction;
    referrer?:  string;
    repId:      string;
    repType?:   RepType;
    sessionId?: string;
    skillId:    string;
    toSeconds?: number;
    userRole:   RepDetailsSelectedUserRole;
    videoUrl:   null | string;
    [property: string]: any;
}

export enum RepResponseVideoTappedAction {
    Paused = "paused",
    Play = "play",
    Scrubbed = "scrubbed",
}

/**
 * Fired when we tap on “Retry” on a rep thread
 */
export interface RepRetrySubmissionTapped {
    aiEnabled:           boolean;
    repAssignmentId:     string;
    selfPracticeEnabled: boolean;
    [property: string]: any;
}

/**
 * Fired when we change the current submission from the rep thread
 */
export interface RepSubmissionToggle {
    aiEnabled:           boolean;
    repAssignmentId:     string;
    selfPracticeEnabled: boolean;
    submissionId:        string;
    submissionType:      SubmissionType;
    [property: string]: any;
}

/**
 * Fired when a user taps “Submit To Coach"
 */
export interface RepSubmitToCoachTapped {
    repAssignmentId: string;
    [property: string]: any;
}

/**
 * when clicking one of the tabs in the gallery
 */
export interface RepTabSelected {
    galleryType: GalleryFilterAppliedGalleryType;
    /**
     * For Coach Gallery the tabs are Review and Approved
     *
     * For Learner Gallery the tabs are
     *
     * With your Coach - Coach
     * With your Peers - Peers
     */
    tab: RepTabSelectedTab;
    [property: string]: any;
}

/**
 * For Coach Gallery the tabs are Review and Approved
 *
 * For Learner Gallery the tabs are
 *
 * With your Coach - Coach
 * With your Peers - Peers
 */
export enum RepTabSelectedTab {
    Approved = "approved",
    Coach = "coach",
    Peers = "peers",
    Portfolio = "portfolio",
    Review = "review",
    UpNext = "upNext",
}

/**
 * User views rep thread
 */
export interface RepThreadViewed {
    aiEnabled:           boolean;
    coachId:             null | string;
    learnerId:           null | string;
    referrer?:           string;
    repId:               string;
    repPoints:           number;
    repStatus:           RepDetailsSelectedRepStatus;
    repType?:            RepType;
    selfPracticeEnabled: boolean;
    sessionId?:          string;
    skillId:             string;
    skillName:           string;
    userRole:            RepDetailsSelectedUserRole;
    [property: string]: any;
}

/**
 * Fired when user taps show/hide graph button
 */
export interface RepToggleGraphVisibility {
    repAssignmentId: string;
    repSubmissionId: string;
    /**
     * true if the user tapped the button to Show the graph. False if he tapped to hide it.
     */
    tappedShow: boolean;
    /**
     * how many video submissions does this rep have, that might be visible in the graph
     */
    videoSubmissionsCount: number;
    [property: string]: any;
}

/**
 * Rep error message download button clicked
 */
export interface RepUploadFailDownloadClicked {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * Triggered to debug steps in uploading a video rep
 */
export interface RepVideoUploadDebug {
    message?: string;
    [property: string]: any;
}

/**
 * Triggered when a link is clicked on the Rep view
 */
export interface RepViewLinkClicked {
    /**
     * Whether it is present on the Rep submission (prompt) or the submission feedback (comment)
     */
    source: RepViewLinkClickedSource;
    [property: string]: any;
}

/**
 * Whether it is present on the Rep submission (prompt) or the submission feedback (comment)
 */
export enum RepViewLinkClickedSource {
    RepSubmission = "rep_submission",
    RepSubmissionFeedback = "rep_submission_feedback",
}

/**
 * Fired when we click read more or read less in the RepsAI part of the rep thread
 */
export interface RepsAIFeedbackVisibilityToggled {
    repAssignmentId: null | string;
    repSubmissionId: null | string;
    /**
     * true if we tapped read more, false otherwise
     */
    tappedReadMore: boolean;
    [property: string]: any;
}

/**
 * an item from search was clicked
 */
export interface SearchItemClicked {
    /**
     * is the skill locked?
     */
    isLocked: boolean;
    /**
     * the text of the item that the user clicked
     */
    itemText: string;
    /**
     * what the user searched for
     */
    searchText: string;
    [property: string]: any;
}

export interface SearchSuccess {
    /**
     * true if this is the first search when opening the screen, useful because it should take
     * more time since clients mights not have any cache yet
     */
    isFirstSearch: boolean;
    /**
     * how many results we got
     */
    resultsCount: number;
    /**
     * the text the user searched for
     */
    text: string;
    /**
     * how many milliseconds it took to get the results
     */
    time: number;
    [property: string]: any;
}

/**
 * Tapped tabs
 */
export interface SigninOptionSelected {
    name:       string;
    referrer?:  string;
    sessionId?: string;
    [property: string]: any;
}

/**
 * Success submit verification code
 */
export interface SigninVerified {
    channel:    Channel;
    referrer?:  string;
    sessionId?: string;
    source:     FailedSendVerificationCodeSource;
    to:         string;
    [property: string]: any;
}

/**
 * On mount Phone Login screen
 */
export interface SigninViewed {
    referrer?:  string;
    sessionId?: string;
    [property: string]: any;
}

/**
 * Fired when we pick the option to leave on the skill when presenting the skill exit
 * confirmation dialog
 */
export interface SkillCloseLeaveTapped {
    /**
     * Starting from 1
     */
    currentLearningCardIndex: number;
    currentLearningCardType:  CurrentLearningCardType;
    learningCardsCount:       number;
    skillProgress:            number;
    [property: string]: any;
}

export enum CurrentLearningCardType {
    File = "file",
    FlashCard = "flash_card",
    Form = "form",
    Linkout = "linkout",
    Unknown = "unknown",
    Video = "video",
}

/**
 * Fired when we're presenting the skill exit confirmation dialog
 */
export interface SkillCloseModalShowed {
    /**
     * Starting from 1
     */
    currentLearningCardIndex: number;
    currentLearningCardType:  CurrentLearningCardType;
    learningCardsCount:       number;
    skillProgress:            number;
    [property: string]: any;
}

/**
 * Fired when we pick the option to stay on the skill when presenting the skill exit
 * confirmation dialog
 */
export interface SkillCloseStayTapped {
    /**
     * Starting from 1
     */
    currentLearningCardIndex: number;
    currentLearningCardType:  CurrentLearningCardType;
    learningCardsCount:       number;
    skillProgress:            number;
    [property: string]: any;
}

/**
 * Skill Completion Card viewed in the Stack flow type
 */
export interface SkillCompletionCardViewed {
    numberOfIncompleteLearningCards: number;
    numberOfLearningCards:           number;
    referrer?:                       string;
    sessionId?:                      string;
    [property: string]: any;
}

export interface SkillCompletionModalViewed {
    referrer?:   string;
    repUnlocked: boolean;
    sessionId?:  string;
    [property: string]: any;
}

/**
 * User tapped the Return button on the Stack flow's skill completion card
 */
export interface SkillIncompleteReturnButtonTapped {
    /**
     * The count of incomplete learning cards this skill has
     */
    numberOfIncompleteLearningCards: number;
    /**
     * The total of learning cards this skill has.
     */
    numberOfLearningCards: number;
    referrer?:             string;
    sessionId?:            string;
    [property: string]: any;
}

export interface SkillPortfolioTabToggled {
    isCoach:    boolean;
    referrer?:  string;
    repTab:     RepTab;
    sessionId?: string;
    userRole:   RepDetailsSelectedUserRole;
    [property: string]: any;
}

export enum RepTab {
    Approved = "approved",
    Todo = "todo",
}

/**
 * User views skill portfolio
 */
export interface SkillPortfolioViewed {
    approvedRepsCount: number;
    isCoach:           boolean;
    /**
     * coaches do not have pending reps
     */
    pendingRepsCount: number | null;
    referrer?:        string;
    repTab?:          RepTab;
    sessionId?:       string;
    toDoRepsCount:    number;
    userRole:         RepDetailsSelectedUserRole;
    [property: string]: any;
}

/**
 * User selects a skill from their learner dashboard
 */
export interface SkillSelected {
    competency?:   string;
    competencyId?: string;
    /**
     * Denotes if the skill was locked at the time of selection
     */
    isLocked:                boolean;
    learningPlan?:           string;
    learningPlanExternalId?: string;
    position:                number | null;
    referrer?:               string;
    row:                     number | null;
    sessionId?:              string;
    skillId:                 string;
    skillName:               null | string;
    skillPoints:             number | null;
    skillProgress:           number | null;
    /**
     * where a skill is clicked/tapped from
     */
    source: SkillSelectedSource | null;
    [property: string]: any;
}

export enum SkillSelectedSource {
    Campaign = "campaign",
    Dashboard = "dashboard",
    HeroSection = "hero_section",
    LearningPlanDetails = "learning_plan_details",
    NextSkillHomeModule = "next_skill_home_module",
    RepThread = "rep_thread",
    Search = "search",
    SkillCompletionModal = "skill_completion_modal",
}

/**
 * User completes a skill sequence
 */
export interface SkillSequenceCompleted {
    referrer?:              string;
    sessionId?:             string;
    skillId:                string;
    skillProgress:          number | null;
    skillSequenceProgress:  number | null;
    skillSequenceStepCount: number;
    skillSequenceType:      SkillSequenceType;
    [property: string]: any;
}

export enum SkillSequenceType {
    Linkout = "linkout",
    Practice = "practice",
    Understand = "understand",
    Unknown = "unknown",
    Watch = "watch",
}

/**
 * User selects a skill sequence i.e Watch, Understand, Practice from the skill page
 */
export interface SkillSequenceSelected {
    referrer?:             string;
    sessionId?:            string;
    skillId:               string;
    skillProgress:         number | null;
    skillSequenceProgress: number | null;
    skillSequenceType:     SkillSequenceType;
    source:                SkillSequenceSelectedSource;
    [property: string]: any;
}

export enum SkillSequenceSelectedSource {
    Autoplay = "autoplay",
    LinkoutButton = "linkout_button",
    PracticeButton = "practice_button",
    Rep = "rep",
    SkillImage = "skill_image",
    UnderstandButton = "understand_button",
    WatchButton = "watch_button",
}

/**
 * User closed a skill using the Stack flow type
 */
export interface SkillStackClosed {
    referrer?:  string;
    sessionId?: string;
    /**
     * total time spent in skill
     */
    skillTotalTimeSeconds: number;
    /**
     * total number of cards viewed by the user during this skill session
     */
    totalCardViews: number;
    /**
     * total number of times the user tapped the Return button before completion
     */
    totalReturnButtonTaps: number;
    [property: string]: any;
}

/**
 * User completed a skill using the Stack flow type (analog of Skill Completed event which
 * will be fired server-side)
 */
export interface SkillStackCompleted {
    /**
     * number of flash cards in skill
     */
    flashCardCount: number;
    /**
     * number of forms in skill
     */
    formCardCount: number;
    /**
     * number of linkouts in skill
     */
    linkoutCardCount: number;
    referrer?:        string;
    sessionId?:       string;
    skillId:          string;
    skillPoints:      number;
    skillStepCount:   number;
    /**
     * number of video cards in skill
     */
    videoCardCount: number;
    [property: string]: any;
}

/**
 * Video button is tapped on a Skill Stack flow
 */
export interface SkillStackFormOpened {
    formId:           string;
    isSkillComplete:  boolean;
    learningCardId:   string;
    referrer?:        string;
    sessionId?:       string;
    skillDescription: string;
    skillId:          string;
    [property: string]: any;
}

/**
 * Video button is tapped on a Skill Stack flow
 */
export interface SkillStackVideoOpened {
    isSkillComplete:  boolean;
    learningCardId:   string;
    referrer?:        string;
    sessionId?:       string;
    skillDescription: string;
    skillId:          string;
    url:              string;
    [property: string]: any;
}

/**
 * User views a skill step (i.e. learning card)
 */
export interface SkillStepViewed {
    learningCardId:     string;
    learningCardType:   RatingModalViewedLearningCardType;
    position:           number;
    referrer?:          string;
    sessionId?:         string;
    skillId:            string;
    skillProgress:      number | null;
    skillSequenceType?: SkillSequenceType;
    [property: string]: any;
}

/**
 * User views skill page/screen
 */
export interface SkillViewed {
    isAutoplay:         boolean;
    linkoutProgress:    number | null;
    practiceProgress:   number | null;
    referrer?:          string;
    sessionId?:         string;
    skillId:            string;
    skillName:          string;
    skillProgress:      number | null;
    understandProgress: number | null;
    watchProgress:      number | null;
    [property: string]: any;
}

export interface SlideScrolled {
    action:                 SlideScrolledAction;
    currentElementPosition: number;
    direction:              Direction;
    sessionId?:             string;
    totalElementsCount:     number;
    [property: string]: any;
}

export enum SlideScrolledAction {
    Click = "click",
    Swipe = "swipe",
}

export enum Direction {
    Next = "next",
    Prev = "prev",
}

export interface SocialPhotoUpdated {
    companyId?: string;
    email?:     string;
    profileId?: string;
    sessionId?: string;
    source?:    string;
    [property: string]: any;
}

export interface SocialPhotoUpdationFailed {
    cause?:     string;
    companyId?: string;
    email?:     string;
    profileId?: string;
    sessionId?: string;
    source?:    string;
    [property: string]: any;
}

export interface SocialRepsSeeAllTapped {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * fired when the input delay is done, and we start the search request
 */
export interface StartSearch {
    /**
     * what the user is searching
     */
    text: string;
    [property: string]: any;
}

/**
 * Success Send verification
 */
export interface SuccessSendVerificationCode {
    channel:    Channel;
    referrer?:  string;
    sessionId?: string;
    source:     FailedSendVerificationCodeSource;
    to:         string;
    [property: string]: any;
}

/**
 * when a user has reached max length in the survey input box
 */
export interface SurveyInputMaxCharReached {
    /**
     * Form id
     */
    formId: string;
    /**
     * prompt id
     */
    promptId: string;
    /**
     * skill id
     */
    skillId: string;
    /**
     * skill name
     */
    skillName: string;
    [property: string]: any;
}

/**
 * When a user clicks into a cell/input field to enter text
 */
export interface TextInputFocused {
    /**
     * loginPhone, loginEmail, repResponse, repFeedback, repApproval
     */
    inputName:  string;
    referrer?:  string;
    sessionId?: string;
    [property: string]: any;
}

/**
 * check lick on left panel of app dashbord
 */
export interface TodayPracticeClicked {
    folderId?:        string;
    learningPlanId?:  string;
    referrer?:        string;
    sessionId?:       string;
    skillExternalId?: string;
    [property: string]: any;
}

/**
 * should be fired when an error occurs while trying to refresh the token
 */
export interface TokenRefreshFailed {
    /**
     * some useful information we receive from the backend about the error
     */
    errorCode: null | string;
    [property: string]: any;
}

/**
 * should be fired when we successfully update our token
 */
export interface TokenRefreshSuccess {
    /**
     * This property is added as a workaround to generate type for events without properties
     */
    _?: null;
    [property: string]: any;
}

/**
 * user taps/clicked on understand image
 */
export interface UnderstandImageTapped {
    /**
     * is the learning card already completed?
     */
    isCompleted: boolean;
    /**
     * is pdf?
     */
    isFile: boolean;
    /**
     * learning card id
     */
    learningCardId: string;
    /**
     * skill name
     */
    skillName: string;
    [property: string]: any;
}

/**
 * tapped when user clients on review after upload failed, and he wants to retry
 */
export interface UploadRepErrorReviewTapped {
    repAssignmentId: string;
    [property: string]: any;
}

/**
 * User logs into CMS or Client App
 */
export interface UserLoggedIn {
    companyExternalId: string;
    method:            Method | null;
    profileExternalId: string;
    referrer?:         string;
    sessionId?:        string;
    [property: string]: any;
}

export enum Method {
    Email = "email",
    Phone = "phone",
    Sso = "sso",
    URL = "url",
}

export interface UserLoggedOut {
    companyExternalId: string;
    profileExternalId: string;
    referrer?:         string;
    sessionId?:        string;
    [property: string]: any;
}

/**
 * User finishes watching the video
 */
export interface VideoCompleted {
    isFullScreen:          boolean;
    isPortrait:            boolean;
    learningCardId:        string;
    referrer?:             string;
    sessionId?:            string;
    skillId:               string;
    skillProgress:         number | null;
    skillSequenceProgress: number | null;
    videoId:               null | string;
    videoLengthSeconds:    number;
    videoUrl:              null | string;
    [property: string]: any;
}

/**
 * User tapped full screen mode
 */
export interface VideoFullScreenToggled {
    isFullScreen: boolean;
    isPortrait:   boolean;
    referrer?:    string;
    sessionId?:   string;
    videoUrl:     null | string;
    [property: string]: any;
}

/**
 * Video is paused on the users device
 */
export interface VideoPaused {
    /**
     * Is the video full screen?
     */
    isFullScreen: boolean;
    /**
     * is the video playing in potrait mode?
     */
    isPortrait:            boolean;
    learningCardId:        string;
    positionSeconds:       number;
    referrer?:             string;
    sessionId?:            string;
    skillId:               string;
    skillProgress:         number | null;
    skillSequenceProgress: number | null;
    videoId:               null | string;
    videoLengthSeconds:    number;
    videoUrl:              null | string;
    [property: string]: any;
}

/**
 * Video is played on the users device
 */
export interface VideoPlayed {
    isFullScreen:          boolean;
    isPortrait:            boolean;
    learningCardId:        string;
    positionSeconds:       number;
    referrer?:             string;
    sessionId?:            string;
    skillId:               string;
    skillProgress:         number | null;
    skillSequenceProgress: number | null;
    videoId:               null | string;
    videoLengthSeconds:    number;
    videoUrl:              null | string;
    [property: string]: any;
}

/**
 * User scrubs through a portion of the video
 */
export interface VideoScrubbed {
    fromSeconds:           number;
    isFullScreen:          boolean;
    isPortrait:            boolean;
    learningCardId:        string;
    referrer?:             string;
    sessionId?:            string;
    skillId:               string;
    skillProgress:         number | null;
    skillSequenceProgress: number | null;
    toSeconds:             number;
    videoId:               null | string;
    videoLengthSeconds:    number;
    videoUrl:              null | string;
    [property: string]: any;
}

export interface VideoStalled {
    isFullScreen:          boolean;
    isPortrait:            boolean;
    learningCardId:        string;
    referrer?:             string;
    sessionId?:            string;
    skillId:               string;
    skillProgress:         number | null;
    skillSequenceProgress: number | null;
    videoId:               null | string;
    videoLengthSeconds:    number;
    videoUrl:              null | string;
    [property: string]: any;
}

/**
 * Ajv is a peer dependency for development builds. It's used to apply run-time validation
 * to message payloads before passing them on to the underlying analytics instance.
 *
 * Note that the production bundle does not depend on Ajv.
 * 
 * You can install it with: `npm install --save-dev ajv`.
 */
import Ajv, { ErrorObject } from 'ajv'

/**
 * The analytics.js snippet should be available via window.analytics.
 * You can install it by following instructions at: https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/
 * Make sure to also include the TypeScript declarations with: `npm install @segment/analytics-next` (install with --save-dev for type definitions only).
 *
 * If you don't want to use the snippet, you can also install the `@segment/analytics-next` library as a *production* dependency and use it like this: 
 * ```ts
 * import { AnalyticsBrowser } from '@segment/analytics-next' 
 * import { setTypewriterOptions } from './analytics'
 *
 * const analytics = AnalyticsBrowser.load({ writeKey: 'SEGMENT_WRITE_KEY' })
 * 
 * setTypewriterOptions({ analytics: analytics })
 */
import type { AnalyticsSnippet, Analytics, AnalyticsBrowser, Options } from '@segment/analytics-next'

declare global {
    interface Window {
        analytics: AnalyticsSnippet;
    }
}

type AnyAnalytics = AnalyticsSnippet | Analytics | AnalyticsBrowser

/** The callback exposed by analytics.js. */
export type Callback = () => void

export type ViolationHandler = (
    message: Record<string, any>,
    violations: ErrorObject[]
) => void

/**
 * The default handler that is fired if none is supplied with setTypewriterOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler: ViolationHandler = (message, violations) => {
    const msg = JSON.stringify(
        {
            type: 'Typewriter JSON Schema Validation Error',
            description:
                `You made an analytics call (${message.event}) using Typewriter that doesn't match the ` +
                'Tracking Plan spec.',
            errors: violations,
        },
        undefined,
        2,
    );

    console.warn(msg);
};

let onViolation = defaultValidationErrorHandler

let analytics: () => AnyAnalytics | undefined = () => {
    return window.analytics;
};

/** Options to customize the runtime behavior of a Typewriter client. */
export interface TypewriterOptions {
    /**
     * Underlying analytics instance where analytics calls are forwarded on to.
     * Defaults to window.analytics.
     */
    analytics?: AnyAnalytics;
    /**
     * Handler fired when if an event does not match its spec. This handler
     * does not fire in production mode, because it requires inlining the full
     * JSON Schema spec for each event in your Tracking Plan.
     *
     * By default, it will throw errors if NODE_ENV = "test" so that tests will fail
     * if a message does not match the spec. Otherwise, errors will be logged to stderr.
     */
    onViolation?: ViolationHandler;
}

/**
 * Updates the run-time configuration of this Typewriter client.
 *
 * @param {TypewriterOptions} options - the options to upsert
 *
 * @typedef {Object} TypewriterOptions
 * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setTypewriterOptions(options: TypewriterOptions) {
    analytics = options.analytics ? () => options.analytics || window.analytics : analytics;
    onViolation = options.onViolation || onViolation
}

/**
    * Validates a message against a JSON Schema using Ajv. If the message
    * is invalid, the `onViolation` handler will be called.
    */
function validateAgainstSchema(
    message: Record<string, any>,
    schema: object
) {
    const ajv = new Ajv({ allErrors: true, verbose: true })

    if (!ajv.validate(schema, message) && ajv.errors) {
        onViolation(message, ajv.errors)
    }
}

/**
 * Helper to attach metadata on Typewriter to outbound requests.
 * This is used for attribution and debugging by the Segment team.
 */
function withTypewriterContext(message: Options = {}): Options {
    return {
        ...message,
        context: {
            ...(message.context || {}),
            typewriter: {
                language: 'typescript',
                version: '9.2.0',
            },
        },
    };
}

/**
 * Fires a 'AcceptTermsModalViewed' track call.
 *
 * @param AcceptTermsModalViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function acceptTermsModalViewed(props: AcceptTermsModalViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Accept_Terms_Modal_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Modal with terms and conditions that appears for first time users","properties":{"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Accept Terms Modal Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'AcceptTermsTapped' track call.
 *
 * @param AcceptTermsTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function acceptTermsTapped(props: AcceptTermsTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Accept_Terms_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"User accepts terms and conditions","properties":{"referrer":{"type":["string"]},"sessionId":{"type":["string"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Accept Terms Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'AllSkillStepsCompleted' track call.
 *
 * @param AllSkillStepsCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function allSkillStepsCompleted(props: AllSkillStepsCompleted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"All_Skill_Steps_Completed","$schema":"http://json-schema.org/draft-07/schema#","description":"User views skill completion message (analog of Skill Completed event which will be fired server-side)","properties":{"linkoutCardCount":{"$id":"/properties/linkoutCardCount","description":"number of linkouts in skill","type":["integer"]},"practiceCardCount":{"$id":"/properties/practiceCardCount","type":["integer","null"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillPoints":{"$id":"/properties/skillPoints","type":"integer"},"skillStepCount":{"$id":"/properties/skillStepCount","type":["integer"]},"understandCardCount":{"$id":"/properties/understandCardCount","type":["integer","null"]},"watchCardCount":{"$id":"/properties/watchCardCount","type":["integer","null"]}},"required":["practiceCardCount","linkoutCardCount","skillId","watchCardCount","understandCardCount","skillStepCount","skillPoints"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('All Skill Steps Completed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'AppModalClicked' track call.
 *
 * @param AppModalClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function appModalClicked(props: AppModalClicked, options?: Options, callback?: Callback): void {

    const schema = {"$id":"App_Modal_Clicked","$schema":"http://json-schema.org/draft-07/schema#","description":"user clicked on app modal","properties":{"label":{"$id":"/properties/label","description":"","enum":["go to app","stay"],"type":"string"}},"required":["label"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('App Modal Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'AppModalViewed' track call.
 *
 * @param AppModalViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function appModalViewed(props: AppModalViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"App_Modal_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"User sees app modal","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('App Modal Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'AppTabSelected' track call.
 *
 * @param AppTabSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function appTabSelected(props: AppTabSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"App_Tab_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects one of the tabs on the bottom in client app","properties":{"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"tab":{"$id":"/properties/tab","enum":["coach_gallery","coached_reps","home","profile","rep_gallery","social_reps"],"type":"string"}},"required":["tab"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('App Tab Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ButtonClicked' track call.
 *
 * @param ButtonClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function buttonClicked(props: ButtonClicked, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Button_Clicked","$schema":"http://json-schema.org/draft-07/schema#","properties":{"label":{"description":"","type":"string"},"location":{"description":"","type":"string"},"sessionId":{"description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Button Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CameraBackgroundToggled' track call.
 *
 * @param CameraBackgroundToggled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function cameraBackgroundToggled(props: CameraBackgroundToggled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Camera_Background_Toggled","$schema":"http://json-schema.org/draft-07/schema#","description":"Triggered when a user selects a background in the video/photo camera","properties":{"appSource":{"$id":"/properties/appSource","description":"The app source where this event was fired","enum":["admin","mobile","pwa"],"type":"string"},"backgroundType":{"$id":"/properties/backgroundType","description":"","enum":["blur","image","none"],"type":"string"}},"required":["appSource","backgroundType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Camera Background Toggled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CampaignDetailsToggled' track call.
 *
 * @param CampaignDetailsToggled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function campaignDetailsToggled(props: CampaignDetailsToggled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Campaign_Details_Toggled","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we show the list of skill & reps in the new campaign screen","properties":{"showing":{"$id":"/properties/showing","description":"true if we showing it, false if we are closing the screen by pressing the X button","type":"boolean"},"source":{"$id":"/properties/source","description":"where do we see this screen from","enum":["rep_creator","rep_thread","skill"],"type":"string"}},"required":["showing","source"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Campaign Details Toggled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CoachFeedViewed' track call.
 *
 * @param CoachFeedViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function coachFeedViewed(props: CoachFeedViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Coach_Feed_Viewed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"totalRepsAwaitingFeedback":{"type":"integer"}},"required":["totalRepsAwaitingFeedback"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Coach Feed Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CoachFeedbackModuleViewed' track call.
 *
 * @param CoachFeedbackModuleViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function coachFeedbackModuleViewed(props: CoachFeedbackModuleViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Coach_Feedback_Module_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Coach views feedback module on rep thread. This module is present for “Pending Reps”.","properties":{"learnerId":{"description":"","type":["string"]},"learnerName":{"type":["string"]},"referrer":{"type":["string"]},"repId":{"type":["string"]},"sessionId":{"type":["string"]},"skillId":{"type":["string"]},"skillName":{"type":["string"]}},"required":["repId","skillId","skillName","learnerName","learnerId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Coach Feedback Module Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CoachRepsHomeModuleViewed' track call.
 *
 * @param CoachRepsHomeModuleViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function coachRepsHomeModuleViewed(props: CoachRepsHomeModuleViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Coach_Reps_Home_Module_Viewed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Coach Reps Home Module Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CoachRepsSeeAllTapped' track call.
 *
 * @param CoachRepsSeeAllTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function coachRepsSeeAllTapped(props: CoachRepsSeeAllTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Coach_Reps_See_All_Tapped","$schema":"http://json-schema.org/draft-07/schema#","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Coach Reps See All Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'CommunityTabToggled' track call.
 *
 * @param CommunityTabToggled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function communityTabToggled(props: CommunityTabToggled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Community_Tab_Toggled","$schema":"http://json-schema.org/draft-07/schema#","properties":{"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"tab":{"$id":"/properties/tab","enum":["everyone","me"],"type":"string"}},"required":["tab"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Community Tab Toggled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FailedSendVerificationCode' track call.
 *
 * @param FailedSendVerificationCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function failedSendVerificationCode(props: FailedSendVerificationCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Failed_Send_Verification_Code","$schema":"http://json-schema.org/draft-07/schema#","description":"Error after send verification code","properties":{"channel":{"description":"","enum":["email","phone"],"type":"string"},"errorMessage":{"type":["string"]},"errorName":{"description":"","type":["string","null"]},"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"source":{"description":"Possible values are: PWA, CMS","enum":["cms","pwa"],"type":"string"},"to":{"type":["string"]}},"required":["channel","errorMessage","source","to","errorName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Failed Send Verification Code', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FailedVerifyVerificationCode' track call.
 *
 * @param FailedVerifyVerificationCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function failedVerifyVerificationCode(props: FailedVerifyVerificationCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Failed_Verify_Verification_Code","$schema":"http://json-schema.org/draft-07/schema#","description":"Error after send verification code","properties":{"channel":{"enum":["email","phone"],"type":"string"},"errorMessage":{"type":["string"]},"errorName":{"description":"","type":["string","null"]},"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"source":{"description":"","enum":["cms","pwa"],"type":"string"},"to":{"type":["string"]}},"required":["source","to","errorMessage","channel","errorName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Failed Verify Verification Code', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FormChoiceSelected' track call.
 *
 * @param FormChoiceSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function formChoiceSelected(props: FormChoiceSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Form_Choice_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects a choice option in forms","properties":{"choiceId":{"$id":"/properties/choiceId","description":"Choice Id from forms","type":"string"},"formDerivedType":{"$id":"/properties/formDerivedType","description":"is this form from a quiz or a survey? ","enum":["graded_quiz","survey","ungraded_quiz","unknown"],"type":"string"},"formId":{"$id":"/properties/formId","description":"id of the form","type":"string"},"passingThreshold":{"$id":"/properties/passingThreshold","description":"minimum correctly answered prompts required to pass","type":["number","null"]},"promptAttemptNumber":{"$id":"/properties/promptAttemptNumber","description":"attempt number at the prompt level, 1 for graded quizzes, 1-n for ungraded quizzes","type":"integer"},"promptId":{"$id":"/properties/promptId","description":"Prompt ID from forms","type":"string"},"promptPosition":{"$id":"/properties/promptPosition","description":"position of Prompt in the form","type":"integer"},"promptPositionInverse":{"$id":"/properties/promptPositionInverse","description":"Inverse position of the prompt within the form","type":"integer"},"skillId":{"$id":"/properties/skillId","description":"The skill ID that the form is associated with","type":"string"},"skillName":{"$id":"/properties/skillName","description":"The name of the skill the form is associated with","type":"string"},"totalPromptCount":{"$id":"/properties/totalPromptCount","description":"total count of prompts in the foorm","type":"integer"},"triesCount":{"$id":"/properties/triesCount","description":"attempt number at the form-level","type":"integer"}},"required":["skillName","formDerivedType","choiceId","promptId","promptAttemptNumber","formId","passingThreshold","skillId","triesCount","promptPosition","promptPositionInverse","totalPromptCount"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Form Choice Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FormChoiceSubmitFailed' track call.
 *
 * @param FormChoiceSubmitFailed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function formChoiceSubmitFailed(props: FormChoiceSubmitFailed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Form_Choice_Submit_Failed","$schema":"http://json-schema.org/draft-07/schema#","description":"Users attempt to submit an answer to a form fails","properties":{"choiceIds":{"$id":"/properties/choiceIds","description":"","type":"array"},"errorCode":{"$id":"/properties/errorCode","description":"","type":"string"},"errorMessage":{"$id":"/properties/errorMessage","description":"","type":"string"},"formDerivedType":{"$id":"/properties/formDerivedType","description":"","enum":["graded_quiz","survey","ungraded_quiz","unknown"],"type":"string"},"formId":{"$id":"/properties/formId","description":"","type":"string"},"passingThreshold":{"$id":"/properties/passingThreshold","description":"minimum correctly answered prompts required to pass","type":["number","null"]},"promptAttemptNumber":{"$id":"/properties/promptAttemptNumber","description":"","type":"integer"},"promptId":{"$id":"/properties/promptId","description":"","type":"string"},"promptPosition":{"$id":"/properties/promptPosition","description":"","type":"integer"},"skillId":{"$id":"/properties/skillId","description":"","type":"string"},"skillName":{"$id":"/properties/skillName","description":"","type":"string"},"totalPromptCount":{"$id":"/properties/totalPromptCount","description":"","type":"integer"},"triesCount":{"$id":"/properties/triesCount","description":"","type":"integer"}},"required":["passingThreshold","promptAttemptNumber","triesCount","formId","totalPromptCount","promptPosition","choiceIds","skillName","errorMessage","promptId","skillId","formDerivedType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Form Choice Submit Failed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FormChoiceSubmitted' track call.
 *
 * @param FormChoiceSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function formChoiceSubmitted(props: FormChoiceSubmitted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Form_Choice_Submitted","$schema":"http://json-schema.org/draft-07/schema#","description":"Use submits an answer to a form prompt","properties":{"choiceIds":{"$id":"/properties/choiceIds","description":"","type":"array"},"formDerivedType":{"$id":"/properties/formDerivedType","description":"","enum":["graded_quiz","survey","ungraded_quiz","unknown"],"type":"string"},"formId":{"$id":"/properties/formId","description":"","type":"string"},"isCorrect":{"$id":"/properties/isCorrect","description":"allows null for surveys","type":["boolean","null"]},"passingThreshold":{"$id":"/properties/passingThreshold","description":"minimum correctly answered prompts required to pass","type":["number","null"]},"promptAttemptNumber":{"$id":"/properties/promptAttemptNumber","description":"the current attempt number for this prompt","type":"integer"},"promptId":{"$id":"/properties/promptId","description":"","type":"string"},"promptPosition":{"$id":"/properties/promptPosition","description":"","type":"integer"},"promptPositionInverse":{"$id":"/properties/promptPositionInverse","description":"","type":"integer"},"skillId":{"$id":"/properties/skillId","description":"","type":"string"},"skillName":{"$id":"/properties/skillName","description":"","type":"string"},"totalPromptCount":{"$id":"/properties/totalPromptCount","description":"","type":"integer"},"triesCount":{"$id":"/properties/triesCount","description":"the current attempt number for this form","type":"integer"}},"required":["passingThreshold","promptPosition","choiceIds","formDerivedType","skillId","promptId","isCorrect","promptPositionInverse","triesCount","skillName","formId","promptAttemptNumber","totalPromptCount"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Form Choice Submitted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FormIntroViewed' track call.
 *
 * @param FormIntroViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function formIntroViewed(props: FormIntroViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Form_Intro_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"User views a Intro to form modal","properties":{"currentFormFailed":{"$id":"/properties/currentFormFailed","description":"if current form has failed","type":"boolean"},"formDerivedType":{"$id":"/properties/formDerivedType","description":"is this form from quiz or survey","enum":["graded_quiz","survey","ungraded_quiz","unknown"],"type":"string"},"formId":{"$id":"/properties/formId","description":"Form ID","type":"string"},"maxTries":{"$id":"/properties/maxTries","description":"maximum number of attempts allowed for this form","type":["integer","null"]},"passingThreshold":{"$id":"/properties/passingThreshold","description":"minimum correctly answered prompts required to pass","type":["number","null"]},"skillId":{"$id":"/properties/skillId","description":"SkillId","type":"string"},"skillName":{"$id":"/properties/skillName","description":"Name of the skill form is associated with","type":"string"},"totalPromptCount":{"$id":"/properties/totalPromptCount","description":"Number of prompts in the form","type":"integer"},"triesCount":{"$id":"/properties/triesCount","description":"number of attempt the user has tried this form","type":"integer"}},"required":["currentFormFailed","maxTries","triesCount","totalPromptCount","passingThreshold","skillId","skillName","formId","formDerivedType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Form Intro Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FormPromptViewed' track call.
 *
 * @param FormPromptViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function formPromptViewed(props: FormPromptViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Form_Prompt_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Firing when user sees a prompt","properties":{"formDerivedType":{"$id":"/properties/formDerivedType","description":"is this form from a quiz or a survey?","enum":["graded_quiz","survey","ungraded_quiz","unknown"],"type":"string"},"formId":{"$id":"/properties/formId","description":"id of the form","type":"string"},"isCompleted":{"$id":"/properties/isCompleted","description":"is this prompt completed?","type":"boolean"},"isFailed":{"$id":"/properties/isFailed","description":"is this prompt failed? can be null if is not completed yet","type":["boolean","null"]},"isReview":{"$id":"/properties/isReview","description":"true if is fired while user is reviewing his answer","type":"boolean"},"maxTries":{"$id":"/properties/maxTries","description":"Maximum number of attempts allowed for the current form","type":["integer","null"]},"passingThreshold":{"$id":"/properties/passingThreshold","description":"minimum correctly answered prompts required to pass","type":["number","null"]},"promptId":{"$id":"/properties/promptId","description":"id of the curent prompt vieed","type":"string"},"promptPosition":{"$id":"/properties/promptPosition","description":"the position of the prompt","type":"integer"},"promptPositionInverse":{"$id":"/properties/promptPositionInverse","description":"the inverse position of the prompt","type":"integer"},"skillId":{"$id":"/properties/skillId","description":"skill id","type":"string"},"skillName":{"$id":"/properties/skillName","description":"Name of skill associated to form","type":"string"},"totalPromptCount":{"$id":"/properties/totalPromptCount","description":"Total number of prompts in the form","type":"integer"},"triesCount":{"$id":"/properties/triesCount","description":"number of attempts for the current form","type":"integer"}},"required":["isFailed","totalPromptCount","maxTries","promptPositionInverse","isReview","passingThreshold","skillId","promptPosition","promptId","triesCount","skillName","isCompleted","formDerivedType","formId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Form Prompt Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FormRetryModalViewed' track call.
 *
 * @param FormRetryModalViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function formRetryModalViewed(props: FormRetryModalViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Form_Retry_Modal_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"user views a retry modal due to failing a form","properties":{"canBeRetried":{"$id":"/properties/canBeRetried","description":"boolean of if user can retry current form","type":"boolean"},"formDerivedType":{"$id":"/properties/formDerivedType","description":"is this form from a quiz or a survey?","enum":["graded_quiz","survey","ungraded_quiz","unknown"],"type":"string"},"formId":{"$id":"/properties/formId","description":"","type":"string"},"maxTries":{"$id":"/properties/maxTries","description":"Maximum number of attempts a user can retry form","type":["integer","null"]},"passingThreshold":{"$id":"/properties/passingThreshold","description":"minimum correctly answered prompts required to pass","type":["number","null"]},"skillId":{"$id":"/properties/skillId","description":"Skill ID","type":"string"},"skillName":{"$id":"/properties/skillName","description":"","type":"string"},"totalPromptCount":{"$id":"/properties/totalPromptCount","description":"","type":"integer"},"triesCount":{"$id":"/properties/triesCount","description":"number of attempts user tried current form","type":"integer"}},"required":["skillId","formId","formDerivedType","triesCount","totalPromptCount","skillName","maxTries","passingThreshold","canBeRetried"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Form Retry Modal Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FormRetrySelected' track call.
 *
 * @param FormRetrySelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function formRetrySelected(props: FormRetrySelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Form_Retry_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"User has clicked to retry a failed form","properties":{"formDerivedType":{"$id":"/properties/formDerivedType","description":"is this form from a quiz or a survey? ","enum":["graded_quiz","survey","ungraded_quiz","unknown"],"type":"string"},"formId":{"$id":"/properties/formId","description":"ID of the form","type":"string"},"maxTries":{"$id":"/properties/maxTries","description":"Maximum number of attempts allowed for the current form","type":["integer","null"]},"passingThreshold":{"$id":"/properties/passingThreshold","description":"minimum correctly answered prompts required to pass","type":["number","null"]},"skillId":{"$id":"/properties/skillId","description":"skill ID","type":"string"},"skillName":{"$id":"/properties/skillName","description":"Name of skill associated to form","type":"string"},"source":{"$id":"/properties/source","description":"where did the user click the retry button? retryModal or intro Modal","enum":["card","intro_modal","retry_modal"],"type":"string"},"totalPromptCount":{"$id":"/properties/totalPromptCount","description":"Total number of prompts in the form","type":"integer"},"triesCount":{"$id":"/properties/triesCount","description":"number of attempts for the current form","type":"integer"}},"required":["skillId","maxTries","source","totalPromptCount","triesCount","formDerivedType","passingThreshold","skillName","formId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Form Retry Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'FormReviewSelected' track call.
 *
 * @param FormReviewSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function formReviewSelected(props: FormReviewSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Form_Review_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"User has clicked to review a failed form","properties":{"formDerivedType":{"$id":"/properties/formDerivedType","description":"is this form from a quiz or a survey? ","enum":["graded_quiz","survey","ungraded_quiz","unknown"],"type":"string"},"formId":{"$id":"/properties/formId","description":"current form id","type":"string"},"maxTries":{"$id":"/properties/maxTries","description":"max tries for the form","type":["integer","null"]},"passingThreshold":{"$id":"/properties/passingThreshold","description":"minimum correctly answered prompts required to pass","type":["number","null"]},"skillId":{"$id":"/properties/skillId","description":"Skill Id ","type":"string"},"skillName":{"$id":"/properties/skillName","description":"Name of skill associated to form","type":"string"},"source":{"$id":"/properties/source","description":"did the user select to review the form from the modal or dismiss the modal","enum":["dismissFormIntroModal","formIntroModal"],"type":"string"},"totalPromptCount":{"$id":"/properties/totalPromptCount","description":"total prompts in the form","type":"integer"},"triesCount":{"$id":"/properties/triesCount","description":"the current attempt number for the form","type":"integer"}},"required":["formDerivedType","skillName","totalPromptCount","maxTries","triesCount","skillId","formId","passingThreshold"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Form Review Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GalleryFilterApplied' track call.
 *
 * @param GalleryFilterApplied props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function galleryFilterApplied(props: GalleryFilterApplied, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Gallery_Filter_Applied","$schema":"http://json-schema.org/draft-07/schema#","properties":{"filtersApplied":{"$id":"/properties/filtersApplied","description":"","properties":{"learnerCompanyProfileId":{"$id":"/properties/properties/properties/filtersApplied/properties/learnerCompanyProfileId","description":"","type":"string"},"promptId":{"$id":"/properties/properties/properties/filtersApplied/properties/promptId","description":"","type":"string"},"status":{"$id":"/properties/properties/properties/filtersApplied/properties/status","description":"always sent when applying a filter in coach gallery","enum":["all","approved","new","reviewed","submitted"],"type":"string"}},"required":[],"type":"object"},"galleryType":{"$id":"/properties/galleryType","description":"","enum":["coach","reps"],"type":"string"},"tab":{"$id":"/properties/tab","description":"","enum":["approved","coach","peers","review"],"type":"string"}},"required":["galleryType","tab","filtersApplied"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Gallery Filter Applied', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GalleryViewed' track call.
 *
 * @param GalleryViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function galleryViewed(props: GalleryViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Gallery_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"When you land on the gallery (either learner or coach) via deeplink or from tab menu. Only fire when first clicking into gallery. If filters are applied after viewing gallery fire the gallery filter applied event instead.","properties":{"filtersApplied":{"$id":"/properties/filtersApplied","description":"","properties":{"learnerCompanyProfileId":{"$id":"/properties/properties/properties/filtersApplied/properties/learnerCompanyProfileId","description":"","type":"string"},"promptId":{"$id":"/properties/properties/properties/filtersApplied/properties/promptId","description":"","type":"string"},"status":{"$id":"/properties/properties/properties/filtersApplied/properties/status","description":"always sent when applying a filter in coach gallery","enum":["all","approved","new","reviewed","submitted"],"type":"string"}},"required":[],"type":"object"},"galleryType":{"$id":"/properties/galleryType","description":"","enum":["coach","coached_reps","reps","social_reps"],"type":"string"}},"required":["galleryType","filtersApplied"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Gallery Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GeneratingAIAnalysisButtonTapped' track call.
 *
 * @param GeneratingAIAnalysisButtonTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function generatingAIAnalysisButtonTapped(props: GeneratingAIAnalysisButtonTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Generating_Ai_Analysis_Button_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"while on the screen when we’re waiting to generate the AI, and user taps a button","properties":{"buttonTapped":{"$id":"/properties/buttonTapped","description":"","enum":["home","startPractice","submitReps"],"type":"string"},"repId":{"$id":"/properties/repId","description":"","type":"string"}},"required":["buttonTapped","repId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Generating Ai Analysis Button Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GoogleSigninAuthVerifyFailure' track call.
 *
 * @param GoogleSigninAuthVerifyFailure props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function googleSigninAuthVerifyFailure(props: GoogleSigninAuthVerifyFailure, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Google_Signin_Auth_Verify_Failure","$schema":"http://json-schema.org/draft-07/schema#","properties":{"cause":{"$id":"/properties/cause","description":"","type":"string"},"email":{"$id":"/properties/email","description":"","type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"source":{"$id":"/properties/source","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Google Signin Auth Verify Failure', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GoogleSigninFailure' track call.
 *
 * @param GoogleSigninFailure props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function googleSigninFailure(props: GoogleSigninFailure, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Google_Signin_Failure","$schema":"http://json-schema.org/draft-07/schema#","description":"Failed to Signin with Google","properties":{"cause":{"$id":"/properties/cause","description":"","type":"string"},"email":{"$id":"/properties/email","description":"","type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"source":{"$id":"/properties/source","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Google Signin Failure', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'GoogleSigninSuccess' track call.
 *
 * @param GoogleSigninSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function googleSigninSuccess(props: GoogleSigninSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Google_Signin_Success","$schema":"http://json-schema.org/draft-07/schema#","description":"Successful Signin with Google","properties":{"email":{"$id":"/properties/email","description":"","type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"},"source":{"$id":"/properties/source","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Google Signin Success', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'InboundURLAuthorized' track call.
 *
 * @param InboundURLAuthorized props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function inboundURLAuthorized(props: InboundURLAuthorized, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Inbound_URL_Authorized","$schema":"http://json-schema.org/draft-07/schema#","description":"URL login; used when Uber users click on link","properties":{"companyExternalId":{"description":"","type":["string","null"]},"competencyExternalId":{"description":"","type":["string","null"]},"instanceId":{"description":"","type":["string","null"]},"isSuccess":{"description":"","type":"boolean"},"learningPlanExternalId":{"description":"","type":["string","null"]},"profileExternalId":{"description":"","type":["string","null"]},"sessionId":{"description":"","type":"string"},"skillExternalId":{"description":"","type":["string","null"]},"url":{"description":"","type":"string"}},"required":["url","isSuccess","competencyExternalId","companyExternalId","instanceId","learningPlanExternalId","profileExternalId","skillExternalId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Inbound URL Authorized', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'InfoViewed' track call.
 *
 * @param InfoViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function infoViewed(props: InfoViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Info_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Information viewed when tapping info/question icon","properties":{"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"source":{"type":["string"]}},"required":["source"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Info Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LHSNavigationClicked' track call.
 *
 * @param LHSNavigationClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function lHSNavigationClicked(props: LHSNavigationClicked, options?: Options, callback?: Callback): void {

    const schema = {"$id":"LHS_Navigation_Clicked","$schema":"http://json-schema.org/draft-07/schema#","description":"User clicked a link in the left hand navigation panel","properties":{"learningPlanId":{"$id":"/properties/learningPlanId","description":"","type":"string"},"lpFolderId":{"$id":"/properties/lpFolderId","description":"","type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"sectionName":{"$id":"/properties/sectionName","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('LHS Navigation Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LHSNavigationPickedSort' track call.
 *
 * @param LHSNavigationPickedSort props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function lHSNavigationPickedSort(props: LHSNavigationPickedSort, options?: Options, callback?: Callback): void {

    const schema = {"$id":"LHS_Navigation_Picked_Sort","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when picking a sort type","properties":{"sortType":{"$id":"/properties/sortType","description":"","enum":["alphabetically","latest"],"type":"string"}},"required":["sortType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('LHS Navigation Picked Sort', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LanguageModalViewed' track call.
 *
 * @param LanguageModalViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function languageModalViewed(props: LanguageModalViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Language_Modal_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Language modal that appears for first time users when they login","properties":{"defaultLanguage":{"description":"","type":"string"},"listOfLanguages":{"items":{"type":"string"},"type":"array"},"numberOfLanguages":{"type":"integer"},"referrer":{"type":["string"]},"sessionId":{"type":["string"]}},"required":["listOfLanguages","numberOfLanguages","defaultLanguage"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Language Modal Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LanguageUpdated' track call.
 *
 * @param LanguageUpdated props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function languageUpdated(props: LanguageUpdated, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Language_Updated","$schema":"http://json-schema.org/draft-07/schema#","description":"When user updates their language","properties":{"previousLanguage":{"type":["string","null"]},"referrer":{"type":["string"]},"selectedLanguage":{"type":["string"]},"sessionId":{"type":["string"]}},"required":["previousLanguage","selectedLanguage"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Language Updated', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LearnerDashboardViewed' track call.
 *
 * @param LearnerDashboardViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function learnerDashboardViewed(props: LearnerDashboardViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Learner_Dashboard_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Fires when user lands on their dashboard page.","properties":{"completedSkillCount":{"type":["integer"]},"isCoach":{"type":["boolean"]},"proScore":{"description":"","type":"number"},"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"startedSkillCount":{"type":["integer"]},"totalRepCount":{"type":"integer"},"totalSkillCount":{"type":["integer"]},"totalToDoRepCount":{"type":"integer"}},"required":["isCoach","startedSkillCount","totalSkillCount","completedSkillCount"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Learner Dashboard Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LearningPlanDetailsClosed' track call.
 *
 * @param LearningPlanDetailsClosed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function learningPlanDetailsClosed(props: LearningPlanDetailsClosed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Learning_Plan_Details_Closed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Learning Plan Details Closed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LearningPlanSelected' track call.
 *
 * @param LearningPlanSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function learningPlanSelected(props: LearningPlanSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Learning_Plan_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when tapping a learning plan","properties":{"externalId":{"$id":"/properties/externalId","description":"","type":["string","null"]},"id":{"$id":"/properties/id","description":"","type":["string","null"]},"isCompleted":{"$id":"/properties/isCompleted","description":"","type":["boolean","null"]},"isLocked":{"$id":"/properties/isLocked","description":"","type":["boolean","null"]},"name":{"$id":"/properties/name","description":"","type":["string","null"]},"position":{"$id":"/properties/position","description":"position in list (index)","type":"integer"},"progress":{"$id":"/properties/progress","description":"","type":["number","null"]},"repCount":{"$id":"/properties/repCount","description":"","type":["integer","null"]},"skillCount":{"$id":"/properties/skillCount","description":"","type":["integer","null"]},"source":{"$id":"/properties/source","description":"","enum":["learning_plan_screen","learning_plans_home_module",null],"type":["string","null"]}},"required":["id","skillCount","name","isLocked","repCount","externalId","source","progress","position","isCompleted"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Learning Plan Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LearningPlanViewed' track call.
 *
 * @param LearningPlanViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function learningPlanViewed(props: LearningPlanViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Learning_Plan_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we get the LP details on the LP screen.","properties":{"approvedRepCount":{"$id":"/properties/approvedRepCount","description":"reps where status = approved","type":"integer"},"completedSkillCount":{"$id":"/properties/completedSkillCount","description":"skills with progress = 1.0","type":"integer"},"externalId":{"$id":"/properties/externalId","description":"","type":["string","null"]},"id":{"$id":"/properties/id","description":"","type":["string","null"]},"isCompleted":{"$id":"/properties/isCompleted","description":"progress = 1.0","type":"boolean"},"isLocked":{"$id":"/properties/isLocked","description":"","type":"boolean"},"lockedRepCount":{"$id":"/properties/lockedRepCount","description":"reps where status = locked","type":"integer"},"name":{"$id":"/properties/name","description":"","type":["string","null"]},"newRepCount":{"$id":"/properties/newRepCount","description":" reps where status = new","type":"integer"},"progress":{"$id":"/properties/progress","description":"","type":"number"},"repCount":{"$id":"/properties/repCount","description":"","type":"integer"},"reviewedRepCount":{"$id":"/properties/reviewedRepCount","description":"reps where status = reviewed","type":"integer"},"skillCount":{"$id":"/properties/skillCount","description":"","type":"integer"},"startedSkillCount":{"$id":"/properties/startedSkillCount","description":"skills with progress > 0.0","type":"integer"},"submittedRepCount":{"$id":"/properties/submittedRepCount","description":"reps where status = submitted","type":"integer"}},"required":["id","repCount","lockedRepCount","reviewedRepCount","completedSkillCount","approvedRepCount","isLocked","isCompleted","skillCount","newRepCount","progress","startedSkillCount","submittedRepCount","externalId","name"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Learning Plan Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LearningPlansClosed' track call.
 *
 * @param LearningPlansClosed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function learningPlansClosed(props: LearningPlansClosed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Learning_Plans_Closed","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when learning plans screen is closed","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Learning Plans Closed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LearningPlansHomeModuleViewed' track call.
 *
 * @param LearningPlansHomeModuleViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function learningPlansHomeModuleViewed(props: LearningPlansHomeModuleViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Learning_Plans_Home_Module_Viewed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"count":{"$id":"/properties/count","description":"","type":["integer","null"]}},"required":["count"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Learning Plans Home Module Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LearningPlansSeeAllTapped' track call.
 *
 * @param LearningPlansSeeAllTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function learningPlansSeeAllTapped(props: LearningPlansSeeAllTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Learning_Plans_See_All_Tapped","$schema":"http://json-schema.org/draft-07/schema#","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Learning Plans See All Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LearningPlansViewed' track call.
 *
 * @param LearningPlansViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function learningPlansViewed(props: LearningPlansViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Learning_Plans_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we get a page of learning plans from the backend","properties":{"currentCount":{"$id":"/properties/currentCount","description":"how many LPs we can currently show to the user","type":"integer"},"responseCount":{"$id":"/properties/responseCount","description":"how many LPs were returned in this response","type":"integer"},"totalCount":{"$id":"/properties/totalCount","description":"how many LPs are assigned to the current user","type":"integer"}},"required":["responseCount","totalCount","currentCount"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Learning Plans Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LinkClicked' track call.
 *
 * @param LinkClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function linkClicked(props: LinkClicked, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Link_Clicked","$schema":"http://json-schema.org/draft-07/schema#","properties":{"label":{"description":"","type":"string"},"linkName":{"description":"","type":"string"},"sessionId":{"description":"","type":"string"},"to":{"description":"","type":"string"}},"required":["to"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Link Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'LinkoutOpened' track call.
 *
 * @param LinkoutOpened props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function linkoutOpened(props: LinkoutOpened, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Linkout_Opened","$schema":"http://json-schema.org/draft-07/schema#","properties":{"isSkillComplete":{"type":["boolean"]},"learningCardId":{"type":["string"]},"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"skillDescription":{"type":["string"]},"skillId":{"type":["string"]},"url":{"type":["string"]}},"required":["learningCardId","skillDescription","skillId","url","isSkillComplete"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Linkout Opened', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'MentionSelected' track call.
 *
 * @param MentionSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function mentionSelected(props: MentionSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Mention_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"Triggered when a user selects a person from the suggestions popup","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Mention Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'MentionStarted' track call.
 *
 * @param MentionStarted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function mentionStarted(props: MentionStarted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Mention_Started","$schema":"http://json-schema.org/draft-07/schema#","description":"Triggered when a user writes @ + a letter","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Mention Started', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'MentionSubmitted' track call.
 *
 * @param MentionSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function mentionSubmitted(props: MentionSubmitted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Mention_Submitted","$schema":"http://json-schema.org/draft-07/schema#","description":"Triggered when a user submits a comment with mention(s)","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Mention Submitted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'NewCodeRequested' track call.
 *
 * @param NewCodeRequested props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function newCodeRequested(props: NewCodeRequested, options?: Options, callback?: Callback): void {

    const schema = {"$id":"New_Code_Requested","$schema":"http://json-schema.org/draft-07/schema#","description":"User requests a new code","properties":{"channel":{"description":"","enum":["email","phone"],"type":"string"},"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"source":{"enum":["cms","pwa"],"type":"string"},"to":{"type":["string"]}},"required":["source","to"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('New Code Requested', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'NextSkillHomeModuleViewed' track call.
 *
 * @param NextSkillHomeModuleViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function nextSkillHomeModuleViewed(props: NextSkillHomeModuleViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Next_Skill_Home_Module_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when UI is at least partially visible","properties":{"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"","type":["string","null"]},"repAssignmentStatus":{"$id":"/properties/repAssignmentStatus","description":"","enum":["approved","new",null,"practiced","reviewed","submitted","unknown"],"type":["string","null"]},"repSubmissionCount":{"$id":"/properties/repSubmissionCount","description":"","type":["integer","null"]},"skillCompleted":{"$id":"/properties/skillCompleted","description":"","type":["boolean","null"]},"skillExternalId":{"$id":"/properties/skillExternalId","description":"","type":["string","null"]},"skillLocked":{"$id":"/properties/skillLocked","description":"","type":["boolean","null"]},"skillLpCompanySectionExternalId":{"$id":"/properties/skillLpCompanySectionExternalId","description":"","type":["string","null"]},"type":{"$id":"/properties/type","description":"","enum":["rep","skill","unknown"],"type":"string"}},"required":["skillLpCompanySectionExternalId","repAssignmentId","repAssignmentStatus","repSubmissionCount","type","skillLocked","skillCompleted","skillExternalId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Next Skill Home Module Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'NextSkillModuleViewed' track call.
 *
 * @param NextSkillModuleViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function nextSkillModuleViewed(props: NextSkillModuleViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Next_Skill_Module_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Learner views next skill module if the rep is approved and there is an incomplete skill.  This module is present for “Approved Reps”","properties":{"nextSkillId":{"type":["string"]},"nextSkillName":{"type":["string"]},"referrer":{"type":["string"]},"repId":{"type":["string"]},"sessionId":{"type":["string"]},"skillId":{"type":["string"]},"skillName":{"type":["string"]}},"required":["skillId","skillName","repId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Next Skill Module Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PhoneCountryChanged' track call.
 *
 * @param PhoneCountryChanged props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function phoneCountryChanged(props: PhoneCountryChanged, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Phone_Country_Changed","$schema":"http://json-schema.org/draft-07/schema#","description":"When selected a country","properties":{"previousCountry":{"type":["string"]},"referrer":{"type":["string"]},"selectedCountry":{"type":["string"]},"sessionId":{"type":["string"]}},"required":["previousCountry","selectedCountry"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Phone Country Changed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'PhotoSourceSelected' track call.
 *
 * @param PhotoSourceSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function photoSourceSelected(props: PhotoSourceSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Photo_Source_Selected","$schema":"http://json-schema.org/draft-07/schema#","properties":{"captureMode":{"$id":"/properties/captureMode","enum":["photo","unknown","video"],"type":"string"},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"source":{"$id":"/properties/source","enum":["camera","library","unknown"],"type":"string"}},"required":["source","captureMode"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Photo Source Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProScoreModuleViewed' track call.
 *
 * @param ProScoreModuleViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function proScoreModuleViewed(props: ProScoreModuleViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"ProScore_Module_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Learner views ProScore module which displays ProScore information as a part of a larger screen","properties":{"points":{"type":["integer"]},"proScore":{"type":["number"]},"proScoreRounded":{"type":["integer"]},"referrer":{"type":["string"]},"repsApproved":{"type":["integer"]},"sessionId":{"type":["string"]},"skillsAssigned":{"type":["integer"]},"skillsCompleted":{"type":["integer"]},"source":{"type":"string"}},"required":["points","proScore","proScoreRounded","repsApproved","skillsAssigned","skillsCompleted","source"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('ProScore Module Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProScoreViewed' track call.
 *
 * @param ProScoreViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function proScoreViewed(props: ProScoreViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"ProScore_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Learner opens up the ProScore modal","properties":{"points":{"type":["integer"]},"proScore":{"type":"number"},"proScoreRounded":{"type":["integer"]},"referrer":{"type":["string"]},"repsApproved":{"type":["integer"]},"sessionId":{"type":["string"]},"skillsAssigned":{"type":["integer"]},"skillsCompleted":{"type":["integer"]},"source":{"enum":["dashboard","modal"],"type":"string"}},"required":["points","proScore","proScoreRounded","repsApproved","skillsAssigned","skillsCompleted","source"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('ProScore Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfileButtonItemTapped' track call.
 *
 * @param ProfileButtonItemTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profileButtonItemTapped(props: ProfileButtonItemTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Button_Item_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"A button from the profile item was clicked","properties":{"buttonText":{"$id":"/properties/buttonText","description":"the text of the button","type":"string"}},"required":["buttonText"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Button Item Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfileButtonTapped' track call.
 *
 * @param ProfileButtonTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profileButtonTapped(props: ProfileButtonTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Button_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we click the profile icon from home","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Button Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfilePhotoDelete' track call.
 *
 * @param ProfilePhotoDelete props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profilePhotoDelete(props: ProfilePhotoDelete, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Photo_Delete","$schema":"http://json-schema.org/draft-07/schema#","description":"User taps on delete option to remove the profile photo","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Photo Delete', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfilePhotoEditFromCamera' track call.
 *
 * @param ProfilePhotoEditFromCamera props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profilePhotoEditFromCamera(props: ProfilePhotoEditFromCamera, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Photo_Edit_From_Camera","$schema":"http://json-schema.org/draft-07/schema#","description":"User picks the option to take a photo from the camera","properties":{"hasExistingPhoto":{"$id":"/properties/hasExistingPhoto","description":"true if the user previously had a uploaded profile photo","type":"boolean"}},"required":["hasExistingPhoto"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Photo Edit From Camera', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfilePhotoEditFromLibrary' track call.
 *
 * @param ProfilePhotoEditFromLibrary props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profilePhotoEditFromLibrary(props: ProfilePhotoEditFromLibrary, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Photo_Edit_From_Library","$schema":"http://json-schema.org/draft-07/schema#","description":"User picks the option to pick a photo from the library","properties":{"hasExistingPhoto":{"$id":"/properties/hasExistingPhoto","description":"true if the user previously had a uploaded profile photo","type":"boolean"}},"required":["hasExistingPhoto"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Photo Edit From Library', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfilePhotoEditTapped' track call.
 *
 * @param ProfilePhotoEditTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profilePhotoEditTapped(props: ProfilePhotoEditTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Photo_Edit_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when the user tapped the avatar","properties":{"hasExistingPhoto":{"$id":"/properties/hasExistingPhoto","description":"true if the user previously had a uploaded profile photo","type":"boolean"}},"required":["hasExistingPhoto"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Photo Edit Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfilePhotoUpdateFailed' track call.
 *
 * @param ProfilePhotoUpdateFailed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profilePhotoUpdateFailed(props: ProfilePhotoUpdateFailed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Photo_Update_Failed","$schema":"http://json-schema.org/draft-07/schema#","description":"Fires when there is an error to delete the photo, or update it, or upload it to cloudinary","properties":{"error":{"$id":"/properties/error","description":"the reason for the error, or any relevant info to debug the cause","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Photo Update Failed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfilePhotoUpdateSuccess' track call.
 *
 * @param ProfilePhotoUpdateSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profilePhotoUpdateSuccess(props: ProfilePhotoUpdateSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Photo_Update_Success","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we successfully edit the profile image (changed or deleted)","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Photo Update Success', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfilePhotoUploadCancelled' track call.
 *
 * @param ProfilePhotoUploadCancelled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profilePhotoUploadCancelled(props: ProfilePhotoUploadCancelled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Photo_Upload_Cancelled","$schema":"http://json-schema.org/draft-07/schema#","description":"Fire if the profile image upload is cancelled","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Photo Upload Cancelled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfilePhotoUploadFailed' track call.
 *
 * @param ProfilePhotoUploadFailed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profilePhotoUploadFailed(props: ProfilePhotoUploadFailed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Photo_Upload_Failed","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when the image upload failed","properties":{"error":{"$id":"/properties/error","description":"","type":["string","null"]}},"required":["error"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Photo Upload Failed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'ProfilePhotoUploadSuccess' track call.
 *
 * @param ProfilePhotoUploadSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function profilePhotoUploadSuccess(props: ProfilePhotoUploadSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Profile_Photo_Upload_Success","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when the image upload was successful","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Profile Photo Upload Success', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RatedLearningCard' track call.
 *
 * @param RatedLearningCard props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function ratedLearningCard(props: RatedLearningCard, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rated_Learning_Card","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects a learning card (e.g. video) rating","properties":{"learningCardId":{"$id":"/properties/learningCardId","type":["string"]},"learningCardType":{"$id":"/properties/learningCardType","enum":["file","flash_card","linkout","quiz","unknown","video"],"type":"string"},"linkoutProgress":{"$id":"/properties/linkoutProgress","type":["number","null"]},"practiceProgress":{"$id":"/properties/practiceProgress","type":["number","null"]},"rating":{"$id":"/properties/rating","type":["integer","null"]},"ratingType":{"$id":"/properties/ratingType","enum":["thumbs"],"type":"string"},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","description":"","type":"string"},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"understandProgress":{"$id":"/properties/understandProgress","type":["number","null"]},"watchProgress":{"$id":"/properties/watchProgress","type":["number","null"]}},"required":["watchProgress","skillProgress","ratingType","skillId","learningCardId","understandProgress","linkoutProgress","practiceProgress","skillName","rating","learningCardType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rated Learning Card', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RatedSkill' track call.
 *
 * @param RatedSkill props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function ratedSkill(props: RatedSkill, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rated_Skill","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects a skill rating","properties":{"linkoutProgress":{"$id":"/properties/linkoutProgress","type":["number","null"]},"practiceProgress":{"$id":"/properties/practiceProgress","type":["number","null"]},"rating":{"$id":"/properties/rating","type":["integer","null"]},"ratingType":{"$id":"/properties/ratingType","enum":["thumbs"],"type":"string"},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","description":"","type":"string"},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"understandProgress":{"$id":"/properties/understandProgress","type":["number","null"]},"watchProgress":{"$id":"/properties/watchProgress","type":["number","null"]}},"required":["skillId","skillProgress","linkoutProgress","understandProgress","watchProgress","rating","ratingType","skillName","practiceProgress"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rated Skill', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RatingModalDismissed' track call.
 *
 * @param RatingModalDismissed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function ratingModalDismissed(props: RatingModalDismissed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rating_Modal_Dismissed","$schema":"http://json-schema.org/draft-07/schema#","description":"A rating modal from a learning card is dismissed automatically or by the user","properties":{"action":{"enum":["closed","selected_rating","timeout"],"type":"string"},"learningCardId":{"type":["string"]},"learningCardType":{"enum":["file","flash_card","linkout","quiz","unknown","video"],"type":"string"},"rating":{"type":"integer"},"ratingType":{"enum":["thumbs"],"type":"string"},"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"skillId":{"type":["string"]}},"required":["learningCardId","learningCardType","skillId","action"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rating Modal Dismissed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RatingModalViewed' track call.
 *
 * @param RatingModalViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function ratingModalViewed(props: RatingModalViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rating_Modal_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"A rating modal is displayed to the user","properties":{"learningCardId":{"$id":"/properties/learningCardId","type":["string"]},"learningCardType":{"$id":"/properties/learningCardType","enum":["file","flash_card","form","linkout","quiz","unknown","video"],"type":"string"},"linkoutProgress":{"$id":"/properties/linkoutProgress","type":["number","null"]},"practiceProgress":{"$id":"/properties/practiceProgress","type":["number","null"]},"rating":{"$id":"/properties/rating","type":["integer","null"]},"ratingType":{"$id":"/properties/ratingType","enum":["thumbs"],"type":"string"},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","type":"number"},"understandProgress":{"$id":"/properties/understandProgress","type":["number","null"]},"watchProgress":{"$id":"/properties/watchProgress","type":["number","null"]}},"required":["understandProgress","practiceProgress","learningCardType","skillId","learningCardId","linkoutProgress","skillProgress","watchProgress","ratingType","rating"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rating Modal Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RecorderOptionClicked' track call.
 *
 * @param RecorderOptionClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function recorderOptionClicked(props: RecorderOptionClicked, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Recorder_Option_Clicked","$schema":"http://json-schema.org/draft-07/schema#","description":"Triggered when a user clicks on any available option of the camera or audio recorder","properties":{"appSource":{"$id":"/properties/appSource","description":"The app source where this event was fired","enum":["admin","mobile","pwa"],"type":"string"},"buttonType":{"$id":"/properties/buttonType","description":"","enum":["backgrounds","cameraOff","cameraOn","micOff","micOn","recordScreenStarted","recordScreenStopped","settings","teleprompterOff","teleprompterOn","upload"],"type":"string"},"responseType":{"$id":"/properties/responseType","description":"","enum":["audio","image","video"],"type":"string"}},"required":["buttonType","responseType","appSource"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Recorder Option Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepAISectionOpened' track call.
 *
 * @param RepAISectionOpened props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repAISectionOpened(props: RepAISectionOpened, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Ai_Section_Opened","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when tapping one of the buttons in the rep thread","properties":{"repId":{"$id":"/properties/repId","description":"","type":"string"},"repSubmissionId":{"$id":"/properties/repSubmissionId","description":"","type":"string"},"repSubmissionType":{"$id":"/properties/repSubmissionType","description":"","enum":["conversation","video"],"type":"string"},"sectionType":{"$id":"/properties/sectionType","description":"","enum":["articulation","conversation","keywords"],"type":"string"}},"required":["repSubmissionId","repSubmissionType","sectionType","repId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Ai Section Opened', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepAITabTapped' track call.
 *
 * @param RepAITabTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repAITabTapped(props: RepAITabTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Ai_Tab_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when tapped a rep thread tab from the AI section","properties":{"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"","type":"string"},"repSubmissionId":{"$id":"/properties/repSubmissionId","description":"","type":"string"},"tab":{"$id":"/properties/tab","description":"","enum":["aiAnalysis","transcript"],"type":"string"}},"required":["repAssignmentId","tab","repSubmissionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Ai Tab Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepArticulationToggled' track call.
 *
 * @param RepArticulationToggled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repArticulationToggled(props: RepArticulationToggled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Articulation_Toggled","$schema":"http://json-schema.org/draft-07/schema#","description":"fired when tapped the articulation to expand to show more AI data","properties":{"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"","type":"string"},"repSubmissionId":{"$id":"/properties/repSubmissionId","description":"","type":"string"},"showArticulation":{"$id":"/properties/showArticulation","description":"true if the tap was made to expand the articulation, false otherwise","type":"boolean"}},"required":["repAssignmentId","showArticulation","repSubmissionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Articulation Toggled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepCreatorModuleViewed' track call.
 *
 * @param RepCreatorModuleViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repCreatorModuleViewed(props: RepCreatorModuleViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Creator_Module_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Learner views rep creator module on rep thread. This module is present for “New Reps” and “Feedback Reps”","properties":{"allowedResponseTypes":{"$id":"/properties/allowedResponseTypes","items":{"$id":"/properties/properties/properties/allowedResponseTypes/items","enum":["audio","conversation","image","pdf","text","unknown","video"],"type":"string"},"type":"array"},"coachId":{"$id":"/properties/coachId","description":"Coach ID If it's a coached Rep, null otherwise","type":["string","null"]},"coachName":{"$id":"/properties/coachName","description":"Coach Name If it's a coached Rep, null otherwise","type":["string","null"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","description":"Rep assignment ID","type":["string"]},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","type":["string"]}},"required":["skillName","repType","allowedResponseTypes","repId","coachId","coachName","skillId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Creator Module Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepCreatorViewed' track call.
 *
 * @param RepCreatorViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repCreatorViewed(props: RepCreatorViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Creator_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"User opens rep creator using the rep creator icon (+)","properties":{"assignedRepsCount":{"$id":"/properties/assignedRepsCount","type":"integer"},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]}},"required":["assignedRepsCount"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Creator Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepDetailsSelected' track call.
 *
 * @param RepDetailsSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repDetailsSelected(props: RepDetailsSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Details_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"Views modal accompanying rep card that surfaces rep prompt","properties":{"isCoach":{"$id":"/properties/isCoach","type":["boolean"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repStatus":{"$id":"/properties/repStatus","description":"","enum":["approved","done","new","practiced","reviewed","submitted","unknown"],"type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","pattern":"","type":["string"]},"userRole":{"$id":"/properties/userRole","enum":["coach","learner"],"type":"string"}},"required":["skillName","isCoach","repId","userRole"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Details Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepDetailsViewed' track call.
 *
 * @param RepDetailsViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repDetailsViewed(props: RepDetailsViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Details_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Views modal accompanying rep card that surfaces rep prompt","properties":{"isCoach":{"$id":"/properties/isCoach","type":["boolean"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repStatus":{"$id":"/properties/repStatus","description":"","enum":["approved","done","new","practiced","reviewed","submitted","unknown"],"type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","pattern":"","type":["string"]},"userRole":{"$id":"/properties/userRole","enum":["coach","learner"],"type":"string"}},"required":["skillName","isCoach","repId","userRole"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Details Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepFeedbackSubmissionFailed' track call.
 *
 * @param RepFeedbackSubmissionFailed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repFeedbackSubmissionFailed(props: RepFeedbackSubmissionFailed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Feedback_Submission_Failed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"errorCode":{"$id":"/properties/errorCode","description":"","type":"string"},"errorMessage":{"$id":"/properties/errorMessage","description":"error from response OR hint/error message we are showing to the user","type":["string","null"]},"feedbackType":{"$id":"/properties/feedbackType","description":"","enum":["approval","comment","feedback","unknown"],"type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"repId":{"$id":"/properties/repId","description":"rep assignment id","type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"}},"required":["repId","errorMessage","feedbackType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Feedback Submission Failed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepFeedbackSubmissionSuccess' track call.
 *
 * @param RepFeedbackSubmissionSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repFeedbackSubmissionSuccess(props: RepFeedbackSubmissionSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Feedback_Submission_Success","$schema":"http://json-schema.org/draft-07/schema#","description":"Feedback is submitted successfully for a rep","properties":{"feedbackType":{"$id":"/properties/feedbackType","description":"","enum":["approval","comment","feedback","unknown"],"type":"string"},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]}},"required":["repId","feedbackType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Feedback Submission Success', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepFeedbackTypeSelected' track call.
 *
 * @param RepFeedbackTypeSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repFeedbackTypeSelected(props: RepFeedbackTypeSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Feedback_Type_Selected","$schema":"http://json-schema.org/draft-07/schema#","properties":{"feedbackType":{"$id":"/properties/feedbackType","type":["string"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"source":{"$id":"/properties/source","enum":["coach portfolio","rep thread"],"type":"string"}},"required":["feedbackType","repId","skillId","source"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Feedback Type Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepNextSkillTapped' track call.
 *
 * @param RepNextSkillTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repNextSkillTapped(props: RepNextSkillTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Next_Skill_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"fired when tapped Next skill while on the rep thread","properties":{"nextRepAssignmentId":{"$id":"/properties/nextRepAssignmentId","description":"","type":["string","null"]},"nextSkillId":{"$id":"/properties/nextSkillId","description":"","type":["string","null"]},"nextSkillType":{"$id":"/properties/nextSkillType","description":"","enum":["rep","skill"],"type":"string"},"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"the rep assignment id of the rep we currently show","type":"string"}},"required":["nextSkillType","nextRepAssignmentId","nextSkillId","repAssignmentId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Next Skill Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepOpened' track call.
 *
 * @param RepOpened props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repOpened(props: RepOpened, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Opened","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects one of the reps from their portfolio","properties":{"repId":{"$id":"/properties/repId","description":"rep assignment id","type":"string"},"repPromptId":{"$id":"/properties/repPromptId","description":"id of the rep prompt","type":"string"},"repStatus":{"$id":"/properties/repStatus","enum":["approved","done","new","practiced","reviewed","submitted"],"type":"string"},"repTitle":{"$id":"/properties/repTitle","description":"title of the rep","type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"source":{"$id":"/properties/source","description":"","enum":["campaign","coach_gallery","coach_reps_home_module","home","next_skill_home_module","reps_gallery","skill_completion_modal","social_reps_home_module"],"type":"string"},"submitterId":{"$id":"/properties/submitterId","description":"Company Profile ID of the Submitter","type":["string","null"]},"userRole":{"$id":"/properties/userRole","enum":["coach","learner","peer"],"type":"string"}},"required":["repType","repId","repStatus","source","userRole","submitterId","repPromptId","repTitle"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Opened', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepPromptToggled' track call.
 *
 * @param RepPromptToggled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repPromptToggled(props: RepPromptToggled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Prompt_Toggled","$schema":"http://json-schema.org/draft-07/schema#","properties":{"action":{"$id":"/properties/action","description":"","enum":["close","open"],"type":"string"},"repId":{"$id":"/properties/repId","description":"rep assignment id","type":"string"},"repSubmissionType":{"$id":"/properties/repSubmissionType","description":"","enum":["audio","conversation","image","pdf","text","video"],"type":"string"},"source":{"$id":"/properties/source","description":"","enum":["rep_creator","rep_view"],"type":"string"}},"required":["source","repSubmissionType","action","repId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Prompt Toggled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseAudioTapped' track call.
 *
 * @param RepResponseAudioTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseAudioTapped(props: RepResponseAudioTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Audio_Tapped","$schema":"http://json-schema.org/draft-07/schema#","properties":{"action":{"$id":"/properties/action","description":"","enum":["paused","played","scrubbed"],"type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"repId":{"$id":"/properties/repId","description":"","type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"},"skillId":{"$id":"/properties/skillId","description":"","type":"string"},"toSeconds":{"$id":"/properties/toSeconds","description":"Used for scrubbed","type":"number"},"url":{"$id":"/properties/url","description":"","type":"string"},"userRole":{"$id":"/properties/userRole","description":"","enum":["coach","learner"],"type":"string"}},"required":["skillId","action","url","userRole","repId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Audio Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseCancel' track call.
 *
 * @param RepResponseCancel props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseCancel(props: RepResponseCancel, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Cancel","$schema":"http://json-schema.org/draft-07/schema#","properties":{"actionType":{"$id":"/properties/actionType","description":"type of action. enum says its name","enum":["canceled","confirmed","viewed",null],"type":["string","null"]}},"required":["actionType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Cancel', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseCaptured' track call.
 *
 * @param RepResponseCaptured props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseCaptured(props: RepResponseCaptured, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Captured","$schema":"http://json-schema.org/draft-07/schema#","description":"Rep ready for preview","properties":{"duration":{"$id":"/properties/duration","description":"duration of the video / audio in seconds","type":"integer"},"repId":{"$id":"/properties/repId","description":"rep assignment id","type":"string"},"responseType":{"$id":"/properties/responseType","description":"","enum":["audio","image","text","video"],"type":"string"},"source":{"$id":"/properties/source","description":"","enum":["frontCamera","microphone","rearCamera","textInput","upload"],"type":"string"}},"required":["responseType","repId","source"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Captured', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseExit' track call.
 *
 * @param RepResponseExit props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseExit(props: RepResponseExit, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Exit","$schema":"http://json-schema.org/draft-07/schema#","description":"Triggered when a user clicks on the X icon of the Rep creator","properties":{"actionType":{"$id":"/properties/actionType","description":"Type of action is a confirmation message is shown, null otherwise","enum":["canceled","confirmed",null,"viewed"],"type":["string","null"]}},"required":["actionType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Exit', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseImageTapped' track call.
 *
 * @param RepResponseImageTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseImageTapped(props: RepResponseImageTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Image_Tapped","$schema":"http://json-schema.org/draft-07/schema#","properties":{"repId":{"$id":"/properties/repId","description":"","type":"string"},"skillId":{"$id":"/properties/skillId","description":"","type":"string"},"url":{"$id":"/properties/url","description":"","type":"string"},"userRole":{"$id":"/properties/userRole","description":"","enum":["coach","learner"],"type":"string"}},"required":["repId","skillId","userRole","url"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Image Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponsePreviewed' track call.
 *
 * @param RepResponsePreviewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponsePreviewed(props: RepResponsePreviewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Previewed","$schema":"http://json-schema.org/draft-07/schema#","description":"The rep response preview is shown. This is prior to the user submitting the response","properties":{"referrer":{"$id":"/properties/referrer","type":["string"]},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"responseType":{"$id":"/properties/responseType","enum":["audio","conversation","image","pdf","text","unknown","video"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]}},"required":["responseType","skillId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Previewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseRecordingStarted' track call.
 *
 * @param RepResponseRecordingStarted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseRecordingStarted(props: RepResponseRecordingStarted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Recording_Started","$schema":"http://json-schema.org/draft-07/schema#","description":"Start recording (video/audio)","properties":{"repId":{"$id":"/properties/repId","description":"rep assignment id","type":"string"},"responseType":{"$id":"/properties/responseType","description":"","enum":["audio","video"],"type":"string"}},"required":["responseType","repId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Recording Started', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseRedoTapped' track call.
 *
 * @param RepResponseRedoTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseRedoTapped(props: RepResponseRedoTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Redo_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"When tapping redo after previewing a rep","properties":{"repId":{"$id":"/properties/repId","description":"rep assignment id","type":"string"},"repSubmissionType":{"$id":"/properties/repSubmissionType","description":"","enum":["audio","conversation","image","text","video"],"type":"string"}},"required":["repId","repSubmissionType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Redo Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseSubmissionCanceled' track call.
 *
 * @param RepResponseSubmissionCanceled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseSubmissionCanceled(props: RepResponseSubmissionCanceled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Submission_Canceled","$schema":"http://json-schema.org/draft-07/schema#","properties":{"repId":{"$id":"/properties/repId","description":"","type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"responseType":{"$id":"/properties/responseType","description":"","enum":["audio","conversation","image","pdf","text","unknown","video"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"}},"required":["repId","responseType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Submission Canceled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseSubmissionFailed' track call.
 *
 * @param RepResponseSubmissionFailed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseSubmissionFailed(props: RepResponseSubmissionFailed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Submission_Failed","$schema":"http://json-schema.org/draft-07/schema#","description":"The attempt to submit rep response failed","properties":{"errorCode":{"$id":"/properties/errorCode","type":"string"},"errorMessage":{"$id":"/properties/errorMessage","type":["string","null"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"responseType":{"$id":"/properties/responseType","enum":["audio","image","pdf","text","unknown","video"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","type":["string"]},"userRole":{"$id":"/properties/userRole","description":"","enum":["coach","learner"],"type":"string"}},"required":["skillId","skillName","repId","userRole","errorMessage","responseType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Submission Failed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseSubmissionSuccess' track call.
 *
 * @param RepResponseSubmissionSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseSubmissionSuccess(props: RepResponseSubmissionSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Submission_Success","$schema":"http://json-schema.org/draft-07/schema#","description":"The rep response was submitted successfully.","properties":{"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"responseType":{"$id":"/properties/responseType","enum":["audio","conversation","image","pdf","text","unknown","video"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","type":["string"]},"userRole":{"$id":"/properties/userRole","description":"","enum":["coach","learner"],"type":"string"}},"required":["skillId","skillName","repId","userRole","responseType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Submission Success', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseSubmitted' track call.
 *
 * @param RepResponseSubmitted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseSubmitted(props: RepResponseSubmitted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Submitted","$schema":"http://json-schema.org/draft-07/schema#","description":"User submits a response on rep thread","properties":{"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repStatus":{"$id":"/properties/repStatus","enum":["approved","new","practiced","reviewed","submitted","unknown"],"type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"responseType":{"$id":"/properties/responseType","enum":["audio","conversation","image","pdf","text","unknown","video"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","type":["string"]},"userRole":{"$id":"/properties/userRole","enum":["coach","learner"],"type":"string"}},"required":["repStatus","responseType","skillId","skillName","repId","userRole"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Submitted', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseTypeSelected' track call.
 *
 * @param RepResponseTypeSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseTypeSelected(props: RepResponseTypeSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Type_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects a response type in Rep Creator and starts the rep creation process.","properties":{"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"responseType":{"$id":"/properties/responseType","enum":["audio","conversation","image","pdf","text","unknown","video"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]}},"required":["responseType","skillId","repId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Type Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseUploadCancelled' track call.
 *
 * @param RepResponseUploadCancelled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseUploadCancelled(props: RepResponseUploadCancelled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Upload_Cancelled","$schema":"http://json-schema.org/draft-07/schema#","properties":{"fileSizeKb":{"$id":"/properties/fileSizeKb","description":"File size of uploaded content in kb","type":"number"},"networkType":{"$id":"/properties/networkType","description":"Network Type","enum":["cellular","unavailable","unknown","wifi"],"type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"repId":{"$id":"/properties/repId","description":"","type":"string"},"repStatus":{"$id":"/properties/repStatus","description":"","enum":["approved","locked","new","reviewed","submitted","unknown"],"type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"responseType":{"$id":"/properties/responseType","description":"","enum":["audio","conversation","image","pdf","text","unknown","video"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"},"skillId":{"$id":"/properties/skillId","description":"","type":"string"},"skillName":{"$id":"/properties/skillName","description":"","type":"string"},"uploadTimeSeconds":{"$id":"/properties/uploadTimeSeconds","description":"Time taken to upload content before cancelling (seconds)","type":"integer"}},"required":["skillId","responseType","repStatus","uploadTimeSeconds","fileSizeKb","networkType","repId","skillName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Upload Cancelled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseUploadFailed' track call.
 *
 * @param RepResponseUploadFailed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseUploadFailed(props: RepResponseUploadFailed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Upload_Failed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"errorCode":{"$id":"/properties/errorCode","type":"string"},"errorMessage":{"$id":"/properties/errorMessage","type":["string"]},"fileSizeKb":{"$id":"/properties/fileSizeKb","description":"File size of uploaded content in kb","type":"number"},"networkError":{"$id":"/properties/networkError","description":"Error returned by the request","type":"object"},"networkType":{"$id":"/properties/networkType","description":"Network type","enum":["cellular","unavailable","unknown","wifi"],"type":"string"},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repStatus":{"$id":"/properties/repStatus","description":"","enum":["approved","new","reviewed","submitted","unknown"],"type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"responseType":{"$id":"/properties/responseType","enum":["audio","conversation","image","pdf","text","unknown","video"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","description":"","type":["string"]},"uploadTimeSeconds":{"$id":"/properties/uploadTimeSeconds","description":"Time taken to upload content before error (seconds)","type":"integer"}},"required":["fileSizeKb","networkType","repStatus","skillId","uploadTimeSeconds","errorMessage","repId","responseType","skillName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Upload Failed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseUploadSuccess' track call.
 *
 * @param RepResponseUploadSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseUploadSuccess(props: RepResponseUploadSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Upload_Success","$schema":"http://json-schema.org/draft-07/schema#","properties":{"fileSizeKb":{"$id":"/properties/fileSizeKb","description":"File size of uploaded content in kb","type":"number"},"networkType":{"$id":"/properties/networkType","description":"Network type","enum":["cellular","unavailable","unknown","wifi"],"type":"string"},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repStatus":{"$id":"/properties/repStatus","description":"","enum":["approved","new","reviewed","submitted","unknown"],"type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"responseType":{"$id":"/properties/responseType","description":"","enum":["audio","conversation","image","pdf","text","unknown","video"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","type":["string"]},"uploadTimeSeconds":{"$id":"/properties/uploadTimeSeconds","description":"Time taken to upload content (seconds)","type":"integer"}},"required":["skillId","repStatus","repId","responseType","skillName","fileSizeKb","uploadTimeSeconds","networkType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Upload Success', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepResponseVideoTapped' track call.
 *
 * @param RepResponseVideoTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repResponseVideoTapped(props: RepResponseVideoTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Response_Video_Tapped","$schema":"http://json-schema.org/draft-07/schema#","properties":{"action":{"$id":"/properties/action","description":"","enum":["paused","play","scrubbed"],"type":"string"},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"toSeconds":{"$id":"/properties/toSeconds","description":"","type":"number"},"userRole":{"$id":"/properties/userRole","description":"","enum":["coach","learner"],"type":"string"},"videoUrl":{"$id":"/properties/videoUrl","type":["string","null"]}},"required":["videoUrl","userRole","repId","skillId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Response Video Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepRetrySubmissionTapped' track call.
 *
 * @param RepRetrySubmissionTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repRetrySubmissionTapped(props: RepRetrySubmissionTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Retry_Submission_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we tap on “Retry” on a rep thread","properties":{"aiEnabled":{"$id":"/properties/aiEnabled","description":"","type":"boolean"},"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"","type":"string"},"selfPracticeEnabled":{"$id":"/properties/selfPracticeEnabled","description":"","type":"boolean"}},"required":["repAssignmentId","selfPracticeEnabled","aiEnabled"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Retry Submission Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepSubmissionToggle' track call.
 *
 * @param RepSubmissionToggle props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repSubmissionToggle(props: RepSubmissionToggle, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Submission_Toggle","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we change the current submission from the rep thread","properties":{"aiEnabled":{"$id":"/properties/aiEnabled","description":"","type":"boolean"},"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"","type":"string"},"selfPracticeEnabled":{"$id":"/properties/selfPracticeEnabled","description":"","type":"boolean"},"submissionId":{"$id":"/properties/submissionId","description":"","type":"string"},"submissionType":{"$id":"/properties/submissionType","description":"","enum":["audio","conversation","image","pdf","text","video"],"type":"string"}},"required":["submissionId","submissionType","repAssignmentId","aiEnabled","selfPracticeEnabled"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Submission Toggle', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepSubmitToCoachTapped' track call.
 *
 * @param RepSubmitToCoachTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repSubmitToCoachTapped(props: RepSubmitToCoachTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Submit_To_Coach_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when a user taps “Submit To Coach\"","properties":{"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"","type":"string"}},"required":["repAssignmentId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Submit To Coach Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepTabSelected' track call.
 *
 * @param RepTabSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repTabSelected(props: RepTabSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Tab_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"when clicking one of the tabs in the gallery","properties":{"galleryType":{"$id":"/properties/galleryType","description":"","enum":["coach","reps"],"type":"string"},"tab":{"$id":"/properties/tab","description":"For Coach Gallery the tabs are Review and Approved\n\nFor Learner Gallery the tabs are \n\nWith your Coach - Coach\nWith your Peers - Peers\n","enum":["approved","coach","peers","portfolio","review","upNext"],"type":"string"}},"required":["galleryType","tab"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Tab Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepThreadViewed' track call.
 *
 * @param RepThreadViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repThreadViewed(props: RepThreadViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Thread_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"User views rep thread","properties":{"aiEnabled":{"$id":"/properties/aiEnabled","description":"","type":"boolean"},"coachId":{"$id":"/properties/coachId","type":["string","null"]},"learnerId":{"$id":"/properties/learnerId","type":["string","null"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"repId":{"$id":"/properties/repId","type":["string"]},"repPoints":{"$id":"/properties/repPoints","type":["integer"]},"repStatus":{"$id":"/properties/repStatus","enum":["approved","done","new","practiced","reviewed","submitted","unknown"],"type":"string"},"repType":{"$id":"/properties/repType","description":"","enum":["coached","social","unknown"],"type":"string"},"selfPracticeEnabled":{"$id":"/properties/selfPracticeEnabled","description":"","type":"boolean"},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","type":["string"]},"userRole":{"$id":"/properties/userRole","enum":["coach","learner"],"type":"string"}},"required":["userRole","selfPracticeEnabled","aiEnabled","learnerId","skillId","repId","repPoints","repStatus","coachId","skillName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Thread Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepToggleGraphVisibility' track call.
 *
 * @param RepToggleGraphVisibility props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repToggleGraphVisibility(props: RepToggleGraphVisibility, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Toggle_Graph_Visibility","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when user taps show/hide graph button","properties":{"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"","type":"string"},"repSubmissionId":{"$id":"/properties/repSubmissionId","description":"","type":"string"},"tappedShow":{"$id":"/properties/tappedShow","description":"true if the user tapped the button to Show the graph. False if he tapped to hide it.","type":"boolean"},"videoSubmissionsCount":{"$id":"/properties/videoSubmissionsCount","description":"how many video submissions does this rep have, that might be visible in the graph","type":"integer"}},"required":["repAssignmentId","videoSubmissionsCount","tappedShow","repSubmissionId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Toggle Graph Visibility', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepUploadFailDownloadClicked' track call.
 *
 * @param RepUploadFailDownloadClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repUploadFailDownloadClicked(props: RepUploadFailDownloadClicked, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Upload_Fail_Download_Clicked","$schema":"http://json-schema.org/draft-07/schema#","description":"Rep error message download button clicked","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Upload Fail Download Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepVideoUploadDebug' track call.
 *
 * @param RepVideoUploadDebug props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repVideoUploadDebug(props: RepVideoUploadDebug, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_Video_Upload_Debug","$schema":"http://json-schema.org/draft-07/schema#","description":"Triggered to debug steps in uploading a video rep","properties":{"message":{"$id":"/properties/message","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep Video Upload Debug', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepViewLinkClicked' track call.
 *
 * @param RepViewLinkClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repViewLinkClicked(props: RepViewLinkClicked, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Rep_View_Link_Clicked","$schema":"http://json-schema.org/draft-07/schema#","description":"Triggered when a link is clicked on the Rep view","properties":{"source":{"$id":"/properties/source","description":"Whether it is present on the Rep submission (prompt) or the submission feedback (comment)","enum":["rep_submission","rep_submission_feedback"],"type":"string"}},"required":["source"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Rep View Link Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'RepsAIFeedbackVisibilityToggled' track call.
 *
 * @param RepsAIFeedbackVisibilityToggled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function repsAIFeedbackVisibilityToggled(props: RepsAIFeedbackVisibilityToggled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"RepsAI_Feedback_Visibility_Toggled","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we click read more or read less in the RepsAI part of the rep thread","properties":{"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"","type":["string","null"]},"repSubmissionId":{"$id":"/properties/repSubmissionId","description":"","type":["string","null"]},"tappedReadMore":{"$id":"/properties/tappedReadMore","description":"true if we tapped read more, false otherwise","type":"boolean"}},"required":["repAssignmentId","repSubmissionId","tappedReadMore"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('RepsAI Feedback Visibility Toggled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SearchItemClicked' track call.
 *
 * @param SearchItemClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function searchItemClicked(props: SearchItemClicked, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Search_Item_Clicked","$schema":"http://json-schema.org/draft-07/schema#","description":"an item from search was clicked","properties":{"isLocked":{"$id":"/properties/isLocked","description":"is the skill locked?","type":"boolean"},"itemText":{"$id":"/properties/itemText","description":"the text of the item that the user clicked","type":"string"},"searchText":{"$id":"/properties/searchText","description":"what the user searched for","type":"string"}},"required":["searchText","itemText","isLocked"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Search Item Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SearchSuccess' track call.
 *
 * @param SearchSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function searchSuccess(props: SearchSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Search_Success","$schema":"http://json-schema.org/draft-07/schema#","properties":{"isFirstSearch":{"$id":"/properties/isFirstSearch","description":"true if this is the first search when opening the screen, useful because it should take more time since clients mights not have any cache yet","type":"boolean"},"resultsCount":{"$id":"/properties/resultsCount","description":"how many results we got","type":"integer"},"text":{"$id":"/properties/text","description":"the text the user searched for","type":"string"},"time":{"$id":"/properties/time","description":"how many milliseconds it took to get the results","type":"integer"}},"required":["text","resultsCount","time","isFirstSearch"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Search Success', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SigninOptionSelected' track call.
 *
 * @param SigninOptionSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function signinOptionSelected(props: SigninOptionSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Signin_Option_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"Tapped tabs","properties":{"name":{"type":["string"]},"referrer":{"type":["string"]},"sessionId":{"type":["string"]}},"required":["name"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Signin Option Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SigninVerified' track call.
 *
 * @param SigninVerified props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function signinVerified(props: SigninVerified, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Signin_Verified","$schema":"http://json-schema.org/draft-07/schema#","description":"Success submit verification code","properties":{"channel":{"enum":["email","phone"],"type":"string"},"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"source":{"enum":["cms","pwa"],"type":"string"},"to":{"type":["string"]}},"required":["channel","source","to"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Signin Verified', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SigninViewed' track call.
 *
 * @param SigninViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function signinViewed(props: SigninViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Signin_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"On mount Phone Login screen","properties":{"referrer":{"type":["string"]},"sessionId":{"type":["string"]}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Signin Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillCloseLeaveTapped' track call.
 *
 * @param SkillCloseLeaveTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillCloseLeaveTapped(props: SkillCloseLeaveTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Close_Leave_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we pick the option to leave on the skill when presenting the skill exit confirmation dialog","properties":{"currentLearningCardIndex":{"$id":"/properties/currentLearningCardIndex","description":"Starting from 1","type":"integer"},"currentLearningCardType":{"$id":"/properties/currentLearningCardType","description":"","enum":["file","flash_card","form","linkout","unknown","video"],"type":"string"},"learningCardsCount":{"$id":"/properties/learningCardsCount","description":"","type":"integer"},"skillProgress":{"$id":"/properties/skillProgress","description":"","type":"number"}},"required":["learningCardsCount","skillProgress","currentLearningCardIndex","currentLearningCardType"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Close Leave Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillCloseModalShowed' track call.
 *
 * @param SkillCloseModalShowed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillCloseModalShowed(props: SkillCloseModalShowed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Close_Modal_Showed","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we're presenting the skill exit confirmation dialog","properties":{"currentLearningCardIndex":{"$id":"/properties/currentLearningCardIndex","description":"Starting from 1","type":"integer"},"currentLearningCardType":{"$id":"/properties/currentLearningCardType","description":"","enum":["file","flash_card","form","linkout","unknown","video"],"type":"string"},"learningCardsCount":{"$id":"/properties/learningCardsCount","description":"","type":"integer"},"skillProgress":{"$id":"/properties/skillProgress","description":"","type":"number"}},"required":["skillProgress","currentLearningCardIndex","currentLearningCardType","learningCardsCount"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Close Modal Showed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillCloseStayTapped' track call.
 *
 * @param SkillCloseStayTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillCloseStayTapped(props: SkillCloseStayTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Close_Stay_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"Fired when we pick the option to stay on the skill when presenting the skill exit confirmation dialog","properties":{"currentLearningCardIndex":{"$id":"/properties/currentLearningCardIndex","description":"Starting from 1","type":"integer"},"currentLearningCardType":{"$id":"/properties/currentLearningCardType","description":"","enum":["file","flash_card","form","linkout","unknown","video"],"type":"string"},"learningCardsCount":{"$id":"/properties/learningCardsCount","description":"","type":"integer"},"skillProgress":{"$id":"/properties/skillProgress","description":"","type":"number"}},"required":["currentLearningCardIndex","currentLearningCardType","learningCardsCount","skillProgress"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Close Stay Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillCompletionCardViewed' track call.
 *
 * @param SkillCompletionCardViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillCompletionCardViewed(props: SkillCompletionCardViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Completion_Card_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"Skill Completion Card viewed in the Stack flow type","properties":{"numberOfIncompleteLearningCards":{"$id":"/properties/numberOfIncompleteLearningCards","description":"","type":"integer"},"numberOfLearningCards":{"$id":"/properties/numberOfLearningCards","description":"","type":"integer"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"}},"required":["numberOfIncompleteLearningCards","numberOfLearningCards"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Completion Card Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillCompletionModalViewed' track call.
 *
 * @param SkillCompletionModalViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillCompletionModalViewed(props: SkillCompletionModalViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Completion_Modal_Viewed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"referrer":{"type":["string"]},"repUnlocked":{"description":"","type":"boolean"},"sessionId":{"type":["string"]}},"required":["repUnlocked"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Completion Modal Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillIncompleteReturnButtonTapped' track call.
 *
 * @param SkillIncompleteReturnButtonTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillIncompleteReturnButtonTapped(props: SkillIncompleteReturnButtonTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Incomplete_Return_Button_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"User tapped the Return button on the Stack flow's skill completion card","properties":{"numberOfIncompleteLearningCards":{"$id":"/properties/numberOfIncompleteLearningCards","description":"The count of incomplete learning cards this skill has","type":"integer"},"numberOfLearningCards":{"$id":"/properties/numberOfLearningCards","description":"The total of learning cards this skill has. ","type":"integer"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"}},"required":["numberOfIncompleteLearningCards","numberOfLearningCards"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Incomplete Return Button Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillPortfolioTabToggled' track call.
 *
 * @param SkillPortfolioTabToggled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillPortfolioTabToggled(props: SkillPortfolioTabToggled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Portfolio_Tab_Toggled","$schema":"http://json-schema.org/draft-07/schema#","properties":{"isCoach":{"type":["boolean"]},"referrer":{"type":["string"]},"repTab":{"enum":["approved","todo"],"type":"string"},"sessionId":{"type":["string"]},"userRole":{"enum":["coach","learner"],"type":"string"}},"required":["isCoach","repTab","userRole"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Portfolio Tab Toggled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillPortfolioViewed' track call.
 *
 * @param SkillPortfolioViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillPortfolioViewed(props: SkillPortfolioViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Portfolio_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"User views skill portfolio","properties":{"approvedRepsCount":{"type":"integer"},"isCoach":{"type":["boolean"]},"pendingRepsCount":{"description":"coaches do not have pending reps","type":["integer","null"]},"referrer":{"type":["string"]},"repTab":{"enum":["approved","todo"],"type":"string"},"sessionId":{"type":["string"]},"toDoRepsCount":{"type":"integer"},"userRole":{"enum":["coach","learner"],"type":"string"}},"required":["pendingRepsCount","userRole","approvedRepsCount","toDoRepsCount","isCoach"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Portfolio Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillSelected' track call.
 *
 * @param SkillSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillSelected(props: SkillSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects a skill from their learner dashboard","properties":{"competency":{"$id":"/properties/competency","type":["string"]},"competencyId":{"$id":"/properties/competencyId","type":["string"]},"isLocked":{"$id":"/properties/isLocked","description":"Denotes if the skill was locked at the time of selection","type":"boolean"},"learningPlan":{"$id":"/properties/learningPlan","description":"","type":"string"},"learningPlanExternalId":{"$id":"/properties/learningPlanExternalId","description":"","type":"string"},"position":{"$id":"/properties/position","type":["integer","null"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"row":{"$id":"/properties/row","type":["integer","null"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","type":["string","null"]},"skillPoints":{"$id":"/properties/skillPoints","type":["integer","null"]},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"source":{"$id":"/properties/source","description":"where a skill is clicked/tapped from","enum":["campaign","dashboard","hero_section","learning_plan_details","next_skill_home_module",null,"rep_thread","search","skill_completion_modal"],"type":["string","null"]}},"required":["source","skillProgress","skillPoints","isLocked","position","row","skillId","skillName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillSequenceCompleted' track call.
 *
 * @param SkillSequenceCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillSequenceCompleted(props: SkillSequenceCompleted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Sequence_Completed","$schema":"http://json-schema.org/draft-07/schema#","description":"User completes a skill sequence","properties":{"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","description":"","type":["number","null"]},"skillSequenceProgress":{"$id":"/properties/skillSequenceProgress","description":"","type":["number","null"]},"skillSequenceStepCount":{"$id":"/properties/skillSequenceStepCount","type":"integer"},"skillSequenceType":{"$id":"/properties/skillSequenceType","enum":["linkout","practice","understand","unknown","watch"],"type":"string"}},"required":["skillId","skillSequenceStepCount","skillSequenceType","skillSequenceProgress","skillProgress"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Sequence Completed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillSequenceSelected' track call.
 *
 * @param SkillSequenceSelected props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillSequenceSelected(props: SkillSequenceSelected, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Sequence_Selected","$schema":"http://json-schema.org/draft-07/schema#","description":"User selects a skill sequence i.e Watch, Understand, Practice from the skill page","properties":{"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"skillSequenceProgress":{"$id":"/properties/skillSequenceProgress","type":["number","null"]},"skillSequenceType":{"$id":"/properties/skillSequenceType","enum":["linkout","practice","understand","unknown","watch"],"type":"string"},"source":{"$id":"/properties/source","enum":["autoplay","linkout_button","practice_button","rep","skill_image","understand_button","watch_button"],"type":"string"}},"required":["skillSequenceProgress","skillSequenceType","source","skillId","skillProgress"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Sequence Selected', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillStackClosed' track call.
 *
 * @param SkillStackClosed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillStackClosed(props: SkillStackClosed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Stack_Closed","$schema":"http://json-schema.org/draft-07/schema#","description":"User closed a skill using the Stack flow type","properties":{"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"},"skillTotalTimeSeconds":{"$id":"/properties/skillTotalTimeSeconds","description":"total time spent in skill","type":"integer"},"totalCardViews":{"$id":"/properties/totalCardViews","description":"total number of cards viewed by the user during this skill session","type":"integer"},"totalReturnButtonTaps":{"$id":"/properties/totalReturnButtonTaps","description":"total number of times the user tapped the Return button before completion","type":"integer"}},"required":["skillTotalTimeSeconds","totalCardViews","totalReturnButtonTaps"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Stack Closed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillStackCompleted' track call.
 *
 * @param SkillStackCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillStackCompleted(props: SkillStackCompleted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Stack_Completed","$schema":"http://json-schema.org/draft-07/schema#","description":"User completed a skill using the Stack flow type (analog of Skill Completed event which will be fired server-side)","properties":{"flashCardCount":{"$id":"/properties/flashCardCount","description":"number of flash cards in skill","type":"integer"},"formCardCount":{"$id":"/properties/formCardCount","description":"number of forms in skill","type":"integer"},"linkoutCardCount":{"$id":"/properties/linkoutCardCount","description":"number of linkouts in skill","type":["integer"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillPoints":{"$id":"/properties/skillPoints","type":"integer"},"skillStepCount":{"$id":"/properties/skillStepCount","type":["integer"]},"videoCardCount":{"$id":"/properties/videoCardCount","description":"number of video cards in skill","type":"integer"}},"required":["flashCardCount","videoCardCount","skillPoints","formCardCount","linkoutCardCount","skillStepCount","skillId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Stack Completed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillStackFormOpened' track call.
 *
 * @param SkillStackFormOpened props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillStackFormOpened(props: SkillStackFormOpened, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Stack_Form_Opened","$schema":"http://json-schema.org/draft-07/schema#","description":"Video button is tapped on a Skill Stack flow","properties":{"formId":{"$id":"/properties/formId","description":"","type":"string"},"isSkillComplete":{"$id":"/properties/isSkillComplete","description":"","type":"boolean"},"learningCardId":{"$id":"/properties/learningCardId","description":"","type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"},"skillDescription":{"$id":"/properties/skillDescription","description":"","type":"string"},"skillId":{"$id":"/properties/skillId","description":"","type":"string"}},"required":["skillId","formId","isSkillComplete","learningCardId","skillDescription"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Stack Form Opened', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillStackVideoOpened' track call.
 *
 * @param SkillStackVideoOpened props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillStackVideoOpened(props: SkillStackVideoOpened, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Stack_Video_Opened","$schema":"http://json-schema.org/draft-07/schema#","description":"Video button is tapped on a Skill Stack flow","properties":{"isSkillComplete":{"$id":"/properties/isSkillComplete","description":"","type":"boolean"},"learningCardId":{"$id":"/properties/learningCardId","description":"","type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"},"skillDescription":{"$id":"/properties/skillDescription","description":"","type":"string"},"skillId":{"$id":"/properties/skillId","description":"","type":"string"},"url":{"$id":"/properties/url","description":"","type":"string"}},"required":["url","learningCardId","isSkillComplete","skillDescription","skillId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Stack Video Opened', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillStepViewed' track call.
 *
 * @param SkillStepViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillStepViewed(props: SkillStepViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Step_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"User views a skill step (i.e. learning card)","properties":{"learningCardId":{"$id":"/properties/learningCardId","type":["string"]},"learningCardType":{"$id":"/properties/learningCardType","enum":["file","flash_card","form","linkout","quiz","unknown","video"],"type":"string"},"position":{"$id":"/properties/position","type":["integer"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"skillSequenceType":{"$id":"/properties/skillSequenceType","enum":["linkout","practice","understand","unknown","watch"],"type":"string"}},"required":["learningCardType","position","skillId","learningCardId","skillProgress"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Step Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SkillViewed' track call.
 *
 * @param SkillViewed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function skillViewed(props: SkillViewed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Skill_Viewed","$schema":"http://json-schema.org/draft-07/schema#","description":"User views skill page/screen","properties":{"isAutoplay":{"$id":"/properties/isAutoplay","type":["boolean"]},"linkoutProgress":{"$id":"/properties/linkoutProgress","type":["number","null"]},"practiceProgress":{"$id":"/properties/practiceProgress","type":["number","null"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillName":{"$id":"/properties/skillName","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"understandProgress":{"$id":"/properties/understandProgress","type":["number","null"]},"watchProgress":{"$id":"/properties/watchProgress","type":["number","null"]}},"required":["linkoutProgress","practiceProgress","skillProgress","skillName","isAutoplay","skillId","understandProgress","watchProgress"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Skill Viewed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SlideScrolled' track call.
 *
 * @param SlideScrolled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function slideScrolled(props: SlideScrolled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Slide_Scrolled","$schema":"http://json-schema.org/draft-07/schema#","properties":{"action":{"description":"","enum":["click","swipe"],"type":"string"},"currentElementPosition":{"description":"","type":"number"},"direction":{"description":"","enum":["next","prev"],"type":"string"},"sessionId":{"description":"","type":"string"},"totalElementsCount":{"description":"","type":"number"}},"required":["action","direction","currentElementPosition","totalElementsCount"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Slide Scrolled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SocialPhotoUpdated' track call.
 *
 * @param SocialPhotoUpdated props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function socialPhotoUpdated(props: SocialPhotoUpdated, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Social_Photo_Updated","$schema":"http://json-schema.org/draft-07/schema#","properties":{"companyId":{"$id":"/properties/companyId","description":"","type":"string"},"email":{"$id":"/properties/email","description":"","type":"string"},"profileId":{"$id":"/properties/profileId","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"},"source":{"$id":"/properties/source","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Social Photo Updated', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SocialPhotoUpdationFailed' track call.
 *
 * @param SocialPhotoUpdationFailed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function socialPhotoUpdationFailed(props: SocialPhotoUpdationFailed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Social_Photo_Updation_Failed","$schema":"http://json-schema.org/draft-07/schema#","properties":{"cause":{"$id":"/properties/cause","description":"","type":"string"},"companyId":{"$id":"/properties/companyId","description":"","type":"string"},"email":{"$id":"/properties/email","description":"","type":"string"},"profileId":{"$id":"/properties/profileId","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"},"source":{"$id":"/properties/source","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Social Photo Updation Failed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SocialRepsSeeAllTapped' track call.
 *
 * @param SocialRepsSeeAllTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function socialRepsSeeAllTapped(props: SocialRepsSeeAllTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Social_Reps_See_All_Tapped","$schema":"http://json-schema.org/draft-07/schema#","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Social Reps See All Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'StartSearch' track call.
 *
 * @param StartSearch props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function startSearch(props: StartSearch, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Start_Search","$schema":"http://json-schema.org/draft-07/schema#","description":"fired when the input delay is done, and we start the search request","properties":{"text":{"$id":"/properties/text","description":"what the user is searching","type":"string"}},"required":["text"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Start Search', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SuccessSendVerificationCode' track call.
 *
 * @param SuccessSendVerificationCode props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function successSendVerificationCode(props: SuccessSendVerificationCode, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Success_Send_Verification_Code","$schema":"http://json-schema.org/draft-07/schema#","description":"Success Send verification","properties":{"channel":{"enum":["email","phone"],"type":"string"},"referrer":{"type":["string"]},"sessionId":{"type":["string"]},"source":{"enum":["cms","pwa"],"type":"string"},"to":{"type":["string"]}},"required":["channel","source","to"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Success Send Verification Code', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'SurveyInputMaxCharReached' track call.
 *
 * @param SurveyInputMaxCharReached props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function surveyInputMaxCharReached(props: SurveyInputMaxCharReached, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Survey_Input_Max_Char_Reached","$schema":"http://json-schema.org/draft-07/schema#","description":"when a user has reached max length in the survey input box","properties":{"formId":{"$id":"/properties/formId","description":"Form id","type":"string"},"promptId":{"$id":"/properties/promptId","description":"prompt id","type":"string"},"skillId":{"$id":"/properties/skillId","description":"skill id","type":"string"},"skillName":{"$id":"/properties/skillName","description":"skill name","type":"string"}},"required":["promptId","skillId","skillName","formId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Survey Input Max Char Reached', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'TextInputFocused' track call.
 *
 * @param TextInputFocused props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function textInputFocused(props: TextInputFocused, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Text_Input_Focused","$schema":"http://json-schema.org/draft-07/schema#","description":"When a user clicks into a cell/input field to enter text","properties":{"inputName":{"description":"loginPhone, loginEmail, repResponse, repFeedback, repApproval","type":["string"]},"referrer":{"type":["string"]},"sessionId":{"type":["string"]}},"required":["inputName"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Text Input Focused', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'TodayPracticeClicked' track call.
 *
 * @param TodayPracticeClicked props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function todayPracticeClicked(props: TodayPracticeClicked, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Today_Practice_Clicked","$schema":"http://json-schema.org/draft-07/schema#","description":"check lick on left panel of app dashbord","properties":{"folderId":{"$id":"/properties/folderId","description":"","type":"string"},"learningPlanId":{"$id":"/properties/learningPlanId","description":"","type":"string"},"referrer":{"$id":"/properties/referrer","description":"","type":"string"},"sessionId":{"$id":"/properties/sessionId","description":"","type":"string"},"skillExternalId":{"$id":"/properties/skillExternalId","description":"","type":"string"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Today Practice Clicked', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'TokenRefreshFailed' track call.
 *
 * @param TokenRefreshFailed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function tokenRefreshFailed(props: TokenRefreshFailed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Token_Refresh_Failed","$schema":"http://json-schema.org/draft-07/schema#","description":"should be fired when an error occurs while trying to refresh the token","properties":{"errorCode":{"$id":"/properties/errorCode","description":"some useful information we receive from the backend about the error","type":["string","null"]}},"required":["errorCode"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Token Refresh Failed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'TokenRefreshSuccess' track call.
 *
 * @param TokenRefreshSuccess props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function tokenRefreshSuccess(props: TokenRefreshSuccess, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Token_Refresh_Success","$schema":"http://json-schema.org/draft-07/schema#","description":"should be fired when we successfully update our token","properties":{"_":{"type":"null","$id":"/properties/_","description":"This property is added as a workaround to generate type for events without properties"}},"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Token Refresh Success', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UnderstandImageTapped' track call.
 *
 * @param UnderstandImageTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function understandImageTapped(props: UnderstandImageTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Understand_Image_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"user taps/clicked on understand image","properties":{"isCompleted":{"$id":"/properties/isCompleted","description":"is the learning card already completed?","type":"boolean"},"isFile":{"$id":"/properties/isFile","description":"is pdf?","type":"boolean"},"learningCardId":{"$id":"/properties/learningCardId","description":"learning card id","type":"string"},"skillName":{"$id":"/properties/skillName","description":"skill name","type":"string"}},"required":["skillName","learningCardId","isFile","isCompleted"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Understand Image Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UploadRepErrorReviewTapped' track call.
 *
 * @param UploadRepErrorReviewTapped props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function uploadRepErrorReviewTapped(props: UploadRepErrorReviewTapped, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Upload_Rep_Error_Review_Tapped","$schema":"http://json-schema.org/draft-07/schema#","description":"tapped when user clients on review after upload failed, and he wants to retry","properties":{"repAssignmentId":{"$id":"/properties/repAssignmentId","description":"","type":"string"}},"required":["repAssignmentId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Upload Rep Error Review Tapped', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLoggedIn' track call.
 *
 * @param UserLoggedIn props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLoggedIn(props: UserLoggedIn, options?: Options, callback?: Callback): void {

    const schema = {"$id":"User_Logged_In","$schema":"http://json-schema.org/draft-07/schema#","description":"User logs into CMS or Client App","properties":{"companyExternalId":{"$id":"/properties/companyExternalId","type":["string"]},"method":{"$id":"/properties/method","description":"","enum":["email",null,"phone","sso","url"],"type":["string","null"]},"profileExternalId":{"$id":"/properties/profileExternalId","type":["string"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]}},"required":["companyExternalId","profileExternalId","method"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('User Logged In', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'UserLoggedOut' track call.
 *
 * @param UserLoggedOut props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function userLoggedOut(props: UserLoggedOut, options?: Options, callback?: Callback): void {

    const schema = {"$id":"User_Logged_Out","$schema":"http://json-schema.org/draft-07/schema#","properties":{"companyExternalId":{"type":["string"]},"profileExternalId":{"type":["string"]},"referrer":{"type":["string"]},"sessionId":{"type":["string"]}},"required":["companyExternalId","profileExternalId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('User Logged Out', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'VideoCompleted' track call.
 *
 * @param VideoCompleted props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function videoCompleted(props: VideoCompleted, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Video_Completed","$schema":"http://json-schema.org/draft-07/schema#","description":"User finishes watching the video","properties":{"isFullScreen":{"$id":"/properties/isFullScreen","description":"","type":"boolean"},"isPortrait":{"$id":"/properties/isPortrait","description":"","type":"boolean"},"learningCardId":{"$id":"/properties/learningCardId","type":["string"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"skillSequenceProgress":{"$id":"/properties/skillSequenceProgress","type":["number","null"]},"videoId":{"$id":"/properties/videoId","description":"","type":["string","null"]},"videoLengthSeconds":{"$id":"/properties/videoLengthSeconds","type":["integer"]},"videoUrl":{"$id":"/properties/videoUrl","description":"","type":["string","null"]}},"required":["skillId","videoLengthSeconds","videoUrl","videoId","isPortrait","isFullScreen","skillSequenceProgress","learningCardId","skillProgress"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Video Completed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'VideoFullScreenToggled' track call.
 *
 * @param VideoFullScreenToggled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function videoFullScreenToggled(props: VideoFullScreenToggled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Video_Full_Screen_Toggled","$schema":"http://json-schema.org/draft-07/schema#","description":"User tapped full screen mode ","properties":{"isFullScreen":{"$id":"/properties/isFullScreen","description":"","type":"boolean"},"isPortrait":{"$id":"/properties/isPortrait","description":"","type":"boolean"},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"videoUrl":{"$id":"/properties/videoUrl","description":"","type":["string","null"]}},"required":["isPortrait","isFullScreen","videoUrl"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Video Full Screen Toggled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'VideoPaused' track call.
 *
 * @param VideoPaused props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function videoPaused(props: VideoPaused, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Video_Paused","$schema":"http://json-schema.org/draft-07/schema#","description":"Video is paused on the users device","properties":{"isFullScreen":{"$id":"/properties/isFullScreen","description":"Is the video full screen?","type":"boolean"},"isPortrait":{"$id":"/properties/isPortrait","description":"is the video playing in potrait mode?","type":"boolean"},"learningCardId":{"$id":"/properties/learningCardId","type":["string"]},"positionSeconds":{"$id":"/properties/positionSeconds","type":["integer"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"skillSequenceProgress":{"$id":"/properties/skillSequenceProgress","type":["number","null"]},"videoId":{"$id":"/properties/videoId","description":"","type":["string","null"]},"videoLengthSeconds":{"$id":"/properties/videoLengthSeconds","type":["integer"]},"videoUrl":{"$id":"/properties/videoUrl","description":"","type":["string","null"]}},"required":["skillId","skillProgress","skillSequenceProgress","videoUrl","videoId","videoLengthSeconds","positionSeconds","isFullScreen","learningCardId","isPortrait"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Video Paused', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'VideoPlayed' track call.
 *
 * @param VideoPlayed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function videoPlayed(props: VideoPlayed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Video_Played","$schema":"http://json-schema.org/draft-07/schema#","description":"Video is played on the users device","properties":{"isFullScreen":{"$id":"/properties/isFullScreen","description":"","type":"boolean"},"isPortrait":{"$id":"/properties/isPortrait","description":"","type":"boolean"},"learningCardId":{"$id":"/properties/learningCardId","type":["string"]},"positionSeconds":{"$id":"/properties/positionSeconds","type":["integer"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"skillSequenceProgress":{"$id":"/properties/skillSequenceProgress","type":["number","null"]},"videoId":{"$id":"/properties/videoId","description":"","type":["string","null"]},"videoLengthSeconds":{"$id":"/properties/videoLengthSeconds","type":["integer"]},"videoUrl":{"$id":"/properties/videoUrl","description":"","type":["string","null"]}},"required":["videoLengthSeconds","skillProgress","isFullScreen","isPortrait","videoId","positionSeconds","skillSequenceProgress","videoUrl","learningCardId","skillId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Video Played', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'VideoScrubbed' track call.
 *
 * @param VideoScrubbed props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function videoScrubbed(props: VideoScrubbed, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Video_Scrubbed","$schema":"http://json-schema.org/draft-07/schema#","description":"User scrubs through a portion of the video","properties":{"fromSeconds":{"$id":"/properties/fromSeconds","type":["integer"]},"isFullScreen":{"$id":"/properties/isFullScreen","description":"","type":"boolean"},"isPortrait":{"$id":"/properties/isPortrait","description":"","type":"boolean"},"learningCardId":{"$id":"/properties/learningCardId","type":["string"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"skillSequenceProgress":{"$id":"/properties/skillSequenceProgress","type":["number","null"]},"toSeconds":{"$id":"/properties/toSeconds","type":["integer"]},"videoId":{"$id":"/properties/videoId","description":"","type":["string","null"]},"videoLengthSeconds":{"$id":"/properties/videoLengthSeconds","type":["integer"]},"videoUrl":{"$id":"/properties/videoUrl","description":"","type":["string","null"]}},"required":["skillProgress","skillSequenceProgress","toSeconds","skillId","videoId","learningCardId","isPortrait","isFullScreen","videoLengthSeconds","videoUrl","fromSeconds"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Video Scrubbed', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}
/**
 * Fires a 'VideoStalled' track call.
 *
 * @param VideoStalled props - The analytics properties that will be sent to Segment.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 	call is fired.
 */
export function videoStalled(props: VideoStalled, options?: Options, callback?: Callback): void {

    const schema = {"$id":"Video_Stalled","$schema":"http://json-schema.org/draft-07/schema#","properties":{"isFullScreen":{"$id":"/properties/isFullScreen","description":"","type":"boolean"},"isPortrait":{"$id":"/properties/isPortrait","description":"","type":"boolean"},"learningCardId":{"$id":"/properties/learningCardId","type":["string"]},"referrer":{"$id":"/properties/referrer","type":["string"]},"sessionId":{"$id":"/properties/sessionId","type":["string"]},"skillId":{"$id":"/properties/skillId","type":["string"]},"skillProgress":{"$id":"/properties/skillProgress","type":["number","null"]},"skillSequenceProgress":{"$id":"/properties/skillSequenceProgress","type":["number","null"]},"videoId":{"$id":"/properties/videoId","description":"","type":["string","null"]},"videoLengthSeconds":{"$id":"/properties/videoLengthSeconds","type":["integer"]},"videoUrl":{"$id":"/properties/videoUrl","description":"","type":["string","null"]}},"required":["videoUrl","videoLengthSeconds","isFullScreen","isPortrait","learningCardId","skillId","skillProgress","skillSequenceProgress","videoId"],"type":"object"};
    validateAgainstSchema(props, schema);

    const a = analytics();
    if (a) {
        a.track('Video Stalled', props || {}, {...options,   context: {
            ...(options?.context || {}),
            typewriter: {
                language: 'typescript',
                version: '',
            },
        },}, callback);
    }
}

const clientAPI = {
    /**
     * Updates the run-time configuration of this Typewriter client.
     *
     * @param {TypewriterOptions} options - the options to upsert
     *
     * @typedef {Object} TypewriterOptions
     * @property {AnyAnalytics} [analytics] - Underlying analytics instance where analytics
     * 		calls are forwarded on to. Defaults to window.analytics.
     * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
     * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
     * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
     * 		will be logged to stderr.
     */
    setTypewriterOptions,

    /**
     * Fires a 'AcceptTermsModalViewed' track call.
     *
     * @param AcceptTermsModalViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    acceptTermsModalViewed,
    /**
     * Fires a 'AcceptTermsTapped' track call.
     *
     * @param AcceptTermsTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    acceptTermsTapped,
    /**
     * Fires a 'AllSkillStepsCompleted' track call.
     *
     * @param AllSkillStepsCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    allSkillStepsCompleted,
    /**
     * Fires a 'AppModalClicked' track call.
     *
     * @param AppModalClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    appModalClicked,
    /**
     * Fires a 'AppModalViewed' track call.
     *
     * @param AppModalViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    appModalViewed,
    /**
     * Fires a 'AppTabSelected' track call.
     *
     * @param AppTabSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    appTabSelected,
    /**
     * Fires a 'ButtonClicked' track call.
     *
     * @param ButtonClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    buttonClicked,
    /**
     * Fires a 'CameraBackgroundToggled' track call.
     *
     * @param CameraBackgroundToggled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    cameraBackgroundToggled,
    /**
     * Fires a 'CampaignDetailsToggled' track call.
     *
     * @param CampaignDetailsToggled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    campaignDetailsToggled,
    /**
     * Fires a 'CoachFeedViewed' track call.
     *
     * @param CoachFeedViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    coachFeedViewed,
    /**
     * Fires a 'CoachFeedbackModuleViewed' track call.
     *
     * @param CoachFeedbackModuleViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    coachFeedbackModuleViewed,
    /**
     * Fires a 'CoachRepsHomeModuleViewed' track call.
     *
     * @param CoachRepsHomeModuleViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    coachRepsHomeModuleViewed,
    /**
     * Fires a 'CoachRepsSeeAllTapped' track call.
     *
     * @param CoachRepsSeeAllTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    coachRepsSeeAllTapped,
    /**
     * Fires a 'CommunityTabToggled' track call.
     *
     * @param CommunityTabToggled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    communityTabToggled,
    /**
     * Fires a 'FailedSendVerificationCode' track call.
     *
     * @param FailedSendVerificationCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    failedSendVerificationCode,
    /**
     * Fires a 'FailedVerifyVerificationCode' track call.
     *
     * @param FailedVerifyVerificationCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    failedVerifyVerificationCode,
    /**
     * Fires a 'FormChoiceSelected' track call.
     *
     * @param FormChoiceSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    formChoiceSelected,
    /**
     * Fires a 'FormChoiceSubmitFailed' track call.
     *
     * @param FormChoiceSubmitFailed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    formChoiceSubmitFailed,
    /**
     * Fires a 'FormChoiceSubmitted' track call.
     *
     * @param FormChoiceSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    formChoiceSubmitted,
    /**
     * Fires a 'FormIntroViewed' track call.
     *
     * @param FormIntroViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    formIntroViewed,
    /**
     * Fires a 'FormPromptViewed' track call.
     *
     * @param FormPromptViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    formPromptViewed,
    /**
     * Fires a 'FormRetryModalViewed' track call.
     *
     * @param FormRetryModalViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    formRetryModalViewed,
    /**
     * Fires a 'FormRetrySelected' track call.
     *
     * @param FormRetrySelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    formRetrySelected,
    /**
     * Fires a 'FormReviewSelected' track call.
     *
     * @param FormReviewSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    formReviewSelected,
    /**
     * Fires a 'GalleryFilterApplied' track call.
     *
     * @param GalleryFilterApplied props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    galleryFilterApplied,
    /**
     * Fires a 'GalleryViewed' track call.
     *
     * @param GalleryViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    galleryViewed,
    /**
     * Fires a 'GeneratingAIAnalysisButtonTapped' track call.
     *
     * @param GeneratingAIAnalysisButtonTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    generatingAIAnalysisButtonTapped,
    /**
     * Fires a 'GoogleSigninAuthVerifyFailure' track call.
     *
     * @param GoogleSigninAuthVerifyFailure props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    googleSigninAuthVerifyFailure,
    /**
     * Fires a 'GoogleSigninFailure' track call.
     *
     * @param GoogleSigninFailure props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    googleSigninFailure,
    /**
     * Fires a 'GoogleSigninSuccess' track call.
     *
     * @param GoogleSigninSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    googleSigninSuccess,
    /**
     * Fires a 'InboundURLAuthorized' track call.
     *
     * @param InboundURLAuthorized props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    inboundURLAuthorized,
    /**
     * Fires a 'InfoViewed' track call.
     *
     * @param InfoViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    infoViewed,
    /**
     * Fires a 'LHSNavigationClicked' track call.
     *
     * @param LHSNavigationClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    lHSNavigationClicked,
    /**
     * Fires a 'LHSNavigationPickedSort' track call.
     *
     * @param LHSNavigationPickedSort props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    lHSNavigationPickedSort,
    /**
     * Fires a 'LanguageModalViewed' track call.
     *
     * @param LanguageModalViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    languageModalViewed,
    /**
     * Fires a 'LanguageUpdated' track call.
     *
     * @param LanguageUpdated props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    languageUpdated,
    /**
     * Fires a 'LearnerDashboardViewed' track call.
     *
     * @param LearnerDashboardViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    learnerDashboardViewed,
    /**
     * Fires a 'LearningPlanDetailsClosed' track call.
     *
     * @param LearningPlanDetailsClosed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    learningPlanDetailsClosed,
    /**
     * Fires a 'LearningPlanSelected' track call.
     *
     * @param LearningPlanSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    learningPlanSelected,
    /**
     * Fires a 'LearningPlanViewed' track call.
     *
     * @param LearningPlanViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    learningPlanViewed,
    /**
     * Fires a 'LearningPlansClosed' track call.
     *
     * @param LearningPlansClosed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    learningPlansClosed,
    /**
     * Fires a 'LearningPlansHomeModuleViewed' track call.
     *
     * @param LearningPlansHomeModuleViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    learningPlansHomeModuleViewed,
    /**
     * Fires a 'LearningPlansSeeAllTapped' track call.
     *
     * @param LearningPlansSeeAllTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    learningPlansSeeAllTapped,
    /**
     * Fires a 'LearningPlansViewed' track call.
     *
     * @param LearningPlansViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    learningPlansViewed,
    /**
     * Fires a 'LinkClicked' track call.
     *
     * @param LinkClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    linkClicked,
    /**
     * Fires a 'LinkoutOpened' track call.
     *
     * @param LinkoutOpened props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    linkoutOpened,
    /**
     * Fires a 'MentionSelected' track call.
     *
     * @param MentionSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    mentionSelected,
    /**
     * Fires a 'MentionStarted' track call.
     *
     * @param MentionStarted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    mentionStarted,
    /**
     * Fires a 'MentionSubmitted' track call.
     *
     * @param MentionSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    mentionSubmitted,
    /**
     * Fires a 'NewCodeRequested' track call.
     *
     * @param NewCodeRequested props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    newCodeRequested,
    /**
     * Fires a 'NextSkillHomeModuleViewed' track call.
     *
     * @param NextSkillHomeModuleViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    nextSkillHomeModuleViewed,
    /**
     * Fires a 'NextSkillModuleViewed' track call.
     *
     * @param NextSkillModuleViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    nextSkillModuleViewed,
    /**
     * Fires a 'PhoneCountryChanged' track call.
     *
     * @param PhoneCountryChanged props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    phoneCountryChanged,
    /**
     * Fires a 'PhotoSourceSelected' track call.
     *
     * @param PhotoSourceSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    photoSourceSelected,
    /**
     * Fires a 'ProScoreModuleViewed' track call.
     *
     * @param ProScoreModuleViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    proScoreModuleViewed,
    /**
     * Fires a 'ProScoreViewed' track call.
     *
     * @param ProScoreViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    proScoreViewed,
    /**
     * Fires a 'ProfileButtonItemTapped' track call.
     *
     * @param ProfileButtonItemTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profileButtonItemTapped,
    /**
     * Fires a 'ProfileButtonTapped' track call.
     *
     * @param ProfileButtonTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profileButtonTapped,
    /**
     * Fires a 'ProfilePhotoDelete' track call.
     *
     * @param ProfilePhotoDelete props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profilePhotoDelete,
    /**
     * Fires a 'ProfilePhotoEditFromCamera' track call.
     *
     * @param ProfilePhotoEditFromCamera props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profilePhotoEditFromCamera,
    /**
     * Fires a 'ProfilePhotoEditFromLibrary' track call.
     *
     * @param ProfilePhotoEditFromLibrary props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profilePhotoEditFromLibrary,
    /**
     * Fires a 'ProfilePhotoEditTapped' track call.
     *
     * @param ProfilePhotoEditTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profilePhotoEditTapped,
    /**
     * Fires a 'ProfilePhotoUpdateFailed' track call.
     *
     * @param ProfilePhotoUpdateFailed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profilePhotoUpdateFailed,
    /**
     * Fires a 'ProfilePhotoUpdateSuccess' track call.
     *
     * @param ProfilePhotoUpdateSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profilePhotoUpdateSuccess,
    /**
     * Fires a 'ProfilePhotoUploadCancelled' track call.
     *
     * @param ProfilePhotoUploadCancelled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profilePhotoUploadCancelled,
    /**
     * Fires a 'ProfilePhotoUploadFailed' track call.
     *
     * @param ProfilePhotoUploadFailed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profilePhotoUploadFailed,
    /**
     * Fires a 'ProfilePhotoUploadSuccess' track call.
     *
     * @param ProfilePhotoUploadSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    profilePhotoUploadSuccess,
    /**
     * Fires a 'RatedLearningCard' track call.
     *
     * @param RatedLearningCard props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    ratedLearningCard,
    /**
     * Fires a 'RatedSkill' track call.
     *
     * @param RatedSkill props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    ratedSkill,
    /**
     * Fires a 'RatingModalDismissed' track call.
     *
     * @param RatingModalDismissed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    ratingModalDismissed,
    /**
     * Fires a 'RatingModalViewed' track call.
     *
     * @param RatingModalViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    ratingModalViewed,
    /**
     * Fires a 'RecorderOptionClicked' track call.
     *
     * @param RecorderOptionClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    recorderOptionClicked,
    /**
     * Fires a 'RepAISectionOpened' track call.
     *
     * @param RepAISectionOpened props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repAISectionOpened,
    /**
     * Fires a 'RepAITabTapped' track call.
     *
     * @param RepAITabTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repAITabTapped,
    /**
     * Fires a 'RepArticulationToggled' track call.
     *
     * @param RepArticulationToggled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repArticulationToggled,
    /**
     * Fires a 'RepCreatorModuleViewed' track call.
     *
     * @param RepCreatorModuleViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repCreatorModuleViewed,
    /**
     * Fires a 'RepCreatorViewed' track call.
     *
     * @param RepCreatorViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repCreatorViewed,
    /**
     * Fires a 'RepDetailsSelected' track call.
     *
     * @param RepDetailsSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repDetailsSelected,
    /**
     * Fires a 'RepDetailsViewed' track call.
     *
     * @param RepDetailsViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repDetailsViewed,
    /**
     * Fires a 'RepFeedbackSubmissionFailed' track call.
     *
     * @param RepFeedbackSubmissionFailed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repFeedbackSubmissionFailed,
    /**
     * Fires a 'RepFeedbackSubmissionSuccess' track call.
     *
     * @param RepFeedbackSubmissionSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repFeedbackSubmissionSuccess,
    /**
     * Fires a 'RepFeedbackTypeSelected' track call.
     *
     * @param RepFeedbackTypeSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repFeedbackTypeSelected,
    /**
     * Fires a 'RepNextSkillTapped' track call.
     *
     * @param RepNextSkillTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repNextSkillTapped,
    /**
     * Fires a 'RepOpened' track call.
     *
     * @param RepOpened props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repOpened,
    /**
     * Fires a 'RepPromptToggled' track call.
     *
     * @param RepPromptToggled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repPromptToggled,
    /**
     * Fires a 'RepResponseAudioTapped' track call.
     *
     * @param RepResponseAudioTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseAudioTapped,
    /**
     * Fires a 'RepResponseCancel' track call.
     *
     * @param RepResponseCancel props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseCancel,
    /**
     * Fires a 'RepResponseCaptured' track call.
     *
     * @param RepResponseCaptured props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseCaptured,
    /**
     * Fires a 'RepResponseExit' track call.
     *
     * @param RepResponseExit props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseExit,
    /**
     * Fires a 'RepResponseImageTapped' track call.
     *
     * @param RepResponseImageTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseImageTapped,
    /**
     * Fires a 'RepResponsePreviewed' track call.
     *
     * @param RepResponsePreviewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponsePreviewed,
    /**
     * Fires a 'RepResponseRecordingStarted' track call.
     *
     * @param RepResponseRecordingStarted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseRecordingStarted,
    /**
     * Fires a 'RepResponseRedoTapped' track call.
     *
     * @param RepResponseRedoTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseRedoTapped,
    /**
     * Fires a 'RepResponseSubmissionCanceled' track call.
     *
     * @param RepResponseSubmissionCanceled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseSubmissionCanceled,
    /**
     * Fires a 'RepResponseSubmissionFailed' track call.
     *
     * @param RepResponseSubmissionFailed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseSubmissionFailed,
    /**
     * Fires a 'RepResponseSubmissionSuccess' track call.
     *
     * @param RepResponseSubmissionSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseSubmissionSuccess,
    /**
     * Fires a 'RepResponseSubmitted' track call.
     *
     * @param RepResponseSubmitted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseSubmitted,
    /**
     * Fires a 'RepResponseTypeSelected' track call.
     *
     * @param RepResponseTypeSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseTypeSelected,
    /**
     * Fires a 'RepResponseUploadCancelled' track call.
     *
     * @param RepResponseUploadCancelled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseUploadCancelled,
    /**
     * Fires a 'RepResponseUploadFailed' track call.
     *
     * @param RepResponseUploadFailed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseUploadFailed,
    /**
     * Fires a 'RepResponseUploadSuccess' track call.
     *
     * @param RepResponseUploadSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseUploadSuccess,
    /**
     * Fires a 'RepResponseVideoTapped' track call.
     *
     * @param RepResponseVideoTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repResponseVideoTapped,
    /**
     * Fires a 'RepRetrySubmissionTapped' track call.
     *
     * @param RepRetrySubmissionTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repRetrySubmissionTapped,
    /**
     * Fires a 'RepSubmissionToggle' track call.
     *
     * @param RepSubmissionToggle props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repSubmissionToggle,
    /**
     * Fires a 'RepSubmitToCoachTapped' track call.
     *
     * @param RepSubmitToCoachTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repSubmitToCoachTapped,
    /**
     * Fires a 'RepTabSelected' track call.
     *
     * @param RepTabSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repTabSelected,
    /**
     * Fires a 'RepThreadViewed' track call.
     *
     * @param RepThreadViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repThreadViewed,
    /**
     * Fires a 'RepToggleGraphVisibility' track call.
     *
     * @param RepToggleGraphVisibility props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repToggleGraphVisibility,
    /**
     * Fires a 'RepUploadFailDownloadClicked' track call.
     *
     * @param RepUploadFailDownloadClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repUploadFailDownloadClicked,
    /**
     * Fires a 'RepVideoUploadDebug' track call.
     *
     * @param RepVideoUploadDebug props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repVideoUploadDebug,
    /**
     * Fires a 'RepViewLinkClicked' track call.
     *
     * @param RepViewLinkClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repViewLinkClicked,
    /**
     * Fires a 'RepsAIFeedbackVisibilityToggled' track call.
     *
     * @param RepsAIFeedbackVisibilityToggled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    repsAIFeedbackVisibilityToggled,
    /**
     * Fires a 'SearchItemClicked' track call.
     *
     * @param SearchItemClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    searchItemClicked,
    /**
     * Fires a 'SearchSuccess' track call.
     *
     * @param SearchSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    searchSuccess,
    /**
     * Fires a 'SigninOptionSelected' track call.
     *
     * @param SigninOptionSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    signinOptionSelected,
    /**
     * Fires a 'SigninVerified' track call.
     *
     * @param SigninVerified props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    signinVerified,
    /**
     * Fires a 'SigninViewed' track call.
     *
     * @param SigninViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    signinViewed,
    /**
     * Fires a 'SkillCloseLeaveTapped' track call.
     *
     * @param SkillCloseLeaveTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillCloseLeaveTapped,
    /**
     * Fires a 'SkillCloseModalShowed' track call.
     *
     * @param SkillCloseModalShowed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillCloseModalShowed,
    /**
     * Fires a 'SkillCloseStayTapped' track call.
     *
     * @param SkillCloseStayTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillCloseStayTapped,
    /**
     * Fires a 'SkillCompletionCardViewed' track call.
     *
     * @param SkillCompletionCardViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillCompletionCardViewed,
    /**
     * Fires a 'SkillCompletionModalViewed' track call.
     *
     * @param SkillCompletionModalViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillCompletionModalViewed,
    /**
     * Fires a 'SkillIncompleteReturnButtonTapped' track call.
     *
     * @param SkillIncompleteReturnButtonTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillIncompleteReturnButtonTapped,
    /**
     * Fires a 'SkillPortfolioTabToggled' track call.
     *
     * @param SkillPortfolioTabToggled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillPortfolioTabToggled,
    /**
     * Fires a 'SkillPortfolioViewed' track call.
     *
     * @param SkillPortfolioViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillPortfolioViewed,
    /**
     * Fires a 'SkillSelected' track call.
     *
     * @param SkillSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillSelected,
    /**
     * Fires a 'SkillSequenceCompleted' track call.
     *
     * @param SkillSequenceCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillSequenceCompleted,
    /**
     * Fires a 'SkillSequenceSelected' track call.
     *
     * @param SkillSequenceSelected props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillSequenceSelected,
    /**
     * Fires a 'SkillStackClosed' track call.
     *
     * @param SkillStackClosed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillStackClosed,
    /**
     * Fires a 'SkillStackCompleted' track call.
     *
     * @param SkillStackCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillStackCompleted,
    /**
     * Fires a 'SkillStackFormOpened' track call.
     *
     * @param SkillStackFormOpened props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillStackFormOpened,
    /**
     * Fires a 'SkillStackVideoOpened' track call.
     *
     * @param SkillStackVideoOpened props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillStackVideoOpened,
    /**
     * Fires a 'SkillStepViewed' track call.
     *
     * @param SkillStepViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillStepViewed,
    /**
     * Fires a 'SkillViewed' track call.
     *
     * @param SkillViewed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    skillViewed,
    /**
     * Fires a 'SlideScrolled' track call.
     *
     * @param SlideScrolled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    slideScrolled,
    /**
     * Fires a 'SocialPhotoUpdated' track call.
     *
     * @param SocialPhotoUpdated props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    socialPhotoUpdated,
    /**
     * Fires a 'SocialPhotoUpdationFailed' track call.
     *
     * @param SocialPhotoUpdationFailed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    socialPhotoUpdationFailed,
    /**
     * Fires a 'SocialRepsSeeAllTapped' track call.
     *
     * @param SocialRepsSeeAllTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    socialRepsSeeAllTapped,
    /**
     * Fires a 'StartSearch' track call.
     *
     * @param StartSearch props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    startSearch,
    /**
     * Fires a 'SuccessSendVerificationCode' track call.
     *
     * @param SuccessSendVerificationCode props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    successSendVerificationCode,
    /**
     * Fires a 'SurveyInputMaxCharReached' track call.
     *
     * @param SurveyInputMaxCharReached props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    surveyInputMaxCharReached,
    /**
     * Fires a 'TextInputFocused' track call.
     *
     * @param TextInputFocused props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    textInputFocused,
    /**
     * Fires a 'TodayPracticeClicked' track call.
     *
     * @param TodayPracticeClicked props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    todayPracticeClicked,
    /**
     * Fires a 'TokenRefreshFailed' track call.
     *
     * @param TokenRefreshFailed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    tokenRefreshFailed,
    /**
     * Fires a 'TokenRefreshSuccess' track call.
     *
     * @param TokenRefreshSuccess props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    tokenRefreshSuccess,
    /**
     * Fires a 'UnderstandImageTapped' track call.
     *
     * @param UnderstandImageTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    understandImageTapped,
    /**
     * Fires a 'UploadRepErrorReviewTapped' track call.
     *
     * @param UploadRepErrorReviewTapped props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    uploadRepErrorReviewTapped,
    /**
     * Fires a 'UserLoggedIn' track call.
     *
     * @param UserLoggedIn props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLoggedIn,
    /**
     * Fires a 'UserLoggedOut' track call.
     *
     * @param UserLoggedOut props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    userLoggedOut,
    /**
     * Fires a 'VideoCompleted' track call.
     *
     * @param VideoCompleted props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    videoCompleted,
    /**
     * Fires a 'VideoFullScreenToggled' track call.
     *
     * @param VideoFullScreenToggled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    videoFullScreenToggled,
    /**
     * Fires a 'VideoPaused' track call.
     *
     * @param VideoPaused props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    videoPaused,
    /**
     * Fires a 'VideoPlayed' track call.
     *
     * @param VideoPlayed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    videoPlayed,
    /**
     * Fires a 'VideoScrubbed' track call.
     *
     * @param VideoScrubbed props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    videoScrubbed,
    /**
     * Fires a 'VideoStalled' track call.
     *
     * @param VideoStalled props - The analytics properties that will be sent to Segment.
     * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
     * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
     * 	call is fired.
     */
    videoStalled,
};

export default new Proxy<typeof clientAPI>(clientAPI, {
    get(target, method) {
        if (typeof method === 'string' && target.hasOwnProperty(method)) {
            return target[method as keyof typeof clientAPI];
        }

        return () => {
            console.warn(`⚠️  You made an analytics call (${String(method)}) that can't be found. Either:
         a) Re-generate your typewriter client: \`npx typewriter\`
         b) Add it to your Tracking Plan: https://app.segment.com/segment-oscb/protocols/tracking-plans/rs_1zTHJU9fd5mt7cndWnd4PgJbMCE`);
            const a = analytics();
            if (a) {
                a.track(
                    'Unknown Analytics Call Fired',
                    {
                        method,
                    },
                    withTypewriterContext(),
                );
            }
        };
    },
});

